// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-29T23:13:12.996Z
// Property: Regency Woods (ID: 6767906449167248)
// Collections: 24 amenities, 12 floorplans (live), 25 photos, 72 POIs, 4 reviews, 6 virtual tours, 5 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449167248",
  "property_external_id": "978678",
  "property_zillow_url": "https://www.zillow.com/apartments/renton-wa/regency-woods/95wnky/",
  "property_apartments_url": "https://www.apartments.com/regency-woods-renton-wa/09qnhd0/",
  "property_google_business_url": "https://www.google.com/maps/place/Regency+Woods/data=!4m2!3m1!1s0x0:0x2d79119d9f357b27?sa=X&ved=2ahUKEwikmfiTo4STAxVkJNAFHZnoASAQ_BJ6BAgREAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "47591404058",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "regency-woods",
  "property_name": "Regency Woods",
  "property_website_url": "https://www.regencywoodsapartmenthomes.com",
  "property_domain": "https://www.regencywoodsapartmenthomes.com",
  "property_address": "1650 Eagle Ridge Dr S",
  "property_full_address": "1650 Eagle Ridge Dr S, Renton, WA 98055",
  "property_address_1": "1650 Eagle Ridge Dr S",
  "property_address_2": null,
  "property_address_city": "Renton",
  "property_address_state": "WA",
  "property_address_zip_full": null,
  "property_address_zip": "98055",
  "property_address_country": "US",
  "property_address_county": "King County",
  "property_neighborhood_address": "Renton Hill",
  "property_address_latitude": "47.4648269",
  "property_address_longitude": "-122.2046728",
  "property_email": "regency@weidner.com",
  "property_phone": "2535533642",
  "property_call_tracking_phone": "425-256-4153",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Greener Renton Hill living starts at Regency Woods.</strong> Explore spacious one-, two-, and three-bedroom <a href=\"/floor-plans\">floor plans</a> with open layouts, in-home laundry, generous storage, and select vaulted ceilings, granite countertops, patios or balconies, and scenic views—then <a href=\"/schedule-a-tour\">schedule a tour</a> to see it in person.</p>",
  "property_long_description": "Come home to relaxed, elegant living at Regency Woods Apartment Homes. Our apartments in Renton are in a vibrant area near Top Golf, Southcenter Mall, and Gene Coulon Memorial Beach Park. Regency Woods offers modern apartments with useful amenities in a warm and active community. It's also pet-friendly, has a courtesy patrol, and provides easy access to I-405 and a Park and Ride.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior view of a large apartment building with a distinctive turret.",
    "public_id": "01a03a7d-b3cf-7000-8a2c-f9640733cae5",
    "storage_key": "property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
    "width": 3072,
    "height": 2046
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "359",
  "property_year_built": "1967",
  "property_year_renovated": null,
  "property_walk_score": "34",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.98607242339833",
  "property_admin_fee": null,
  "property_application_fee": "50",
  "property_fees_deposit_info": "Deposit: $600",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "300",
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://regencywoodsapartmenthomes.securecafe.com/onlineleasing/regency-woods-2/floorplans.aspx",
  "property_resident_portal_url": "https://regencywoodsapartmenthomes.securecafenet.com/residentservices/regency-woods-2/userlogin",
  "property_apply_now_url": "https://regencywoodsapartmenthomes.securecafe.com/onlineleasing/regency-woods-2/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03f09-7b8c-71e5-b0e8-9a8a5c506189.webp",
  "property_primary_logo_media": {
    "alt_text": "Regency Woods Apartment Homes logo",
    "public_id": "01a03f09-7b8c-71e5-b0e8-9a8a5c506189",
    "storage_key": "property/6767906449167248/01a03f09-7b8c-71e5-b0e8-9a8a5c506189.webp",
    "width": 97,
    "height": 75
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03f09-bcde-77ac-ab56-8eedb7a1fb45.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "01a03f09-bcde-77ac-ab56-8eedb7a1fb45",
    "storage_key": "property/6767906449167248/01a03f09-bcde-77ac-ab56-8eedb7a1fb45.webp",
    "width": 97,
    "height": 75
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03f09-b248-779b-bc4e-45a54be9916a.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a03f09-b248-779b-bc4e-45a54be9916a",
    "storage_key": "property/6767906449167248/01a03f09-b248-779b-bc4e-45a54be9916a.webp",
    "width": 97,
    "height": 75
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#99795b",
  "property_secondary_color": "#0f3e36",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": " - 1050",
  "property_sqft_min": "635",
  "property_sqft_max": "1050",
  "property_price_range": "1650 - 2835",
  "property_price_min": "1650",
  "property_price_max": "2835",
  "property_available_units": 31,
  "property_facebook_url": "https://www.facebook.com/RegencyWoodsApartments",
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJOSyqAkVdkFQRJ3s1n50ReS0",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Regency Woods Apartments",
  "property_home_romance_title": "Welcome to Regency Woods",
  "property_home_amenities_blurb": "<p><strong>Everyday ease, with room to recharge.</strong> At Regency Woods, community amenities bring convenience close to home—work out in the fitness center, unwind by the seasonal pool or indoor spa, and enjoy mature landscaping throughout the grounds. Inside, stainless steel appliances, in-home laundry, open living space, and a patio or balcony add practical comfort, while select homes offer upgrades like granite countertops, vaulted ceilings, scenic views, built-in storage, and walk-in closets.</p>",
  "property_home_floorplans_blurb": "<p><strong>Choose the layout that lives the way you do.</strong> Regency Woods offers one-, two-, and three-bedroom apartments in Renton Hill, including cottage-style homes with dens, optional carports, and three-bedroom, two-bath designs. Open living areas, full-size washers and dryers, stainless steel appliances, patios or balconies, and smart storage come standard, with select homes adding vaulted ceilings, granite countertops, scenic views, built-ins, walk-in closets, or double vanities.</p>",
  "property_home_gallery_blurb": "<p><strong>Preview Regency Woods in vivid detail.</strong> Flip through bright kitchens with maple cabinetry and stainless steel appliances, open living spaces leading to a patio or balcony, and select homes with vaulted ceilings, built-ins, or scenic views. The gallery also captures leafy walkways, an outdoor pool and spa, inviting community spaces, and a window-lined fitness center with cardio and weight equipment.</p>",
  "property_home_neighborhood_blurb": "<p>Regency Woods places you right where you want to be in Renton. Head to Topgolf for a friendly competition, shop the day away at Southcenter Mall, or relax along the water at Gene Coulon Memorial Beach Park. Great dining and daily errands are all close by, and major employers and easy commutes are just minutes from your door. With quick access to I-405 and a nearby Park and Ride, you can make the most of every day, whether you work from home or journey across the city.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents keep coming back to the details:</strong> a hillside setting, polished grounds, refreshed interiors, and everyday convenience that feels easy to appreciate. Reviews point to stainless steel appliances, thoughtfully designed kitchens, a pool and water fountain, leafy surroundings, and views toward city lights and the Cascades—plus responsive maintenance and helpful leasing support from move-in onward.</p>",
  "property_neighborhood_blurb": "<p>Life at Regency Woods lets you experience the best of Renton. Spend weekends at Topgolf or unwind at Gene Coulon Memorial Beach Park by the water. Southcenter Mall is nearby for shopping, dining, and entertainment. Daily commutes are easier here, with quick access to I-405 and a Park and Ride, putting popular employers and city adventures within reach. Explore scenic parks, local eateries, and the vibrant pulse of Renton from a community designed for convenience and connection.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Experience daily comfort at Regency Woods in Renton, WA. Inside your apartment, enjoy stainless steel appliances, in-unit laundry, and, in select homes, vaulted ceilings or built-in office setups. Step outside to a 24-hour fitness center, seasonal pool, spa, and outdoor grilling areas. Our community also offers smoke-free spaces and beautifully landscaped grounds for meeting neighbors or unwinding after a long day.</p>",
  "property_applynow_blurb": "<p><strong>Start your Regency Woods application online.</strong> Choose from flexible one-, two-, and three-bedroom <a href=\"/floor-plans\">floor plans</a> with open living areas, in-home laundry, generous storage, and select scenic views—all set in a quieter Renton Hill community with everyday access close by.</p>",
  "property_contactus_blurb": "<p>Connect with the Regency Woods team in Renton, WA, to learn more about our apartments, schedule a tour, or inquire about floor plan options and availability. Our leasing professionals are here to help you find the perfect fit for your lifestyle at Regency Woods.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Regency Woods?</strong> Start here for quick answers about the community, leasing, floor plans, home features, and everyday life on the greener side of Renton Hill. If you do not see what you need, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p>Regency Woods offers one-, two-, and three-bedroom apartments for rent in Renton, WA. Each home is crafted for comfort and convenience, with select layouts featuring vaulted ceilings and in-unit laundry. Imagine a dining nook for cozy meals, ample storage, and inviting living spaces perfect for work or relaxation. Whether you need a quiet retreat or space for gathering, find a floor plan that fits your lifestyle at Regency Woods.</p>",
  "property_gallery_blurb": "<p>Take a peek inside life at Regency Woods. The gallery welcomes you with bright kitchens, stainless steel finishes, inviting living rooms, and glimpses of the outdoor spaces that make everyday moments comfortable. Picture friendly gatherings near the pool, quiet mornings on your patio, or moments cooking in your modern kitchen. Browse the photos and see what your future could look like at Regency Woods in Renton.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Regency Woods from every angle.</strong> Use the interactive map to browse available apartments, see the community’s greener Renton Hill setting, and get a feel for nearby shopping, dining, transit access, waterfront trails, and everyday destinations close to home.</p>",
  "property_pets_blurb": "<p><strong>Room to roam, space to relax.</strong> Regency Woods makes pet-friendly apartment living in Renton feel easy, with cats, dogs, and select small pets welcome, plus no weight limit for cats and dogs—breed restrictions apply. Step out into a leafy walk-up community for daily fresh-air breaks, then come home to practical comforts like open layouts, in-home laundry, and patios or balconies in many homes.</p><p>When your dog needs a bigger adventure, nearby Cedar River Dog Park offers off-leash space along the trail, while the surrounding area gives you convenient options for everyday walks and pet errands. Browse <a href=\"/floor-plans\">available floor plans</a>, explore <a href=\"/amenities\">community amenities</a>, or <a href=\"/contact-us\">contact the leasing team</a> with pet-policy questions before you apply.</p>",
  "property_referafriend_blurb": "<p><strong>Share the greener side of Renton Hill.</strong><br>Love the quiet hillside setting, flexible floor plans, in-home conveniences, and easy access to everyday destinations? Refer a friend to Regency Woods and invite them to discover the comfort, scenery, and convenience you enjoy close to home.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Regency Woods.</strong><br>Settle into everyday ease on Renton Hill. Log in to pay rent, submit maintenance requests, and manage your account—so you can get back to enjoying the quiet residential setting, mature landscaping, and convenient comforts of home.</p>",
  "property_reviews_blurb": "<p><strong>Hear Regency Woods in residents’ own words.</strong> As you browse the reviews, you’ll notice recurring praise for the hillside setting, well-kept grounds, updated apartment finishes, and everyday ease that residents describe here.</p><p>Reviewers highlight comfortable homes with stainless steel appliances, refreshed interiors, and kitchens that feel thoughtfully designed. Outside, comments call out the pool, water fountain, greenery, and views of city lights and the Cascades. Service also stands out, with one resident noting they were “very impressed with the response time and efficiency of the maintenance staff,” while others mention helpful leasing support and a smooth move-in experience.</p>",
  "property_created_at": "1771543464004",
  "property_scheduletour_blurb": "<p>Ready to explore Regency Woods? Tour your way - pick a private in-person visit or schedule a guided virtual tour. Our knowledgeable team can walk you through available floor plans and show you around the fitness center and swimming pool. Check the calendar to book your spot. Touring restrictions may apply, so connect with our leasing professionals for details and an easy tour experience.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you for reaching out to Regency Woods.</strong><br>Your inquiry has been received, and the leasing team will follow up soon. In the meantime, picture a greener Renton Hill setting with hillside scenery, flexible floor plans, open living areas, in-home laundry, and relaxing community spaces that make everyday life feel easy.</p>",
  "property_virtualtours_blurb": "<p>Take a virtual stroll through Regency Woods without leaving your couch. Our online tours let you see apartment layouts, community spaces, and the vibe of Renton living. Whether you're planning a move from across town or out of state, it's a simple way to picture yourself at home. From kitchens to patios to the inviting social areas, experience the warmth and comfort waiting for you at Regency Woods.</p>",
  "property_copyright": "2026 All Rights Reserved. Regency Woods",
  "property_seo_title_home": "Relaxed apartment living | Regency Woods | Renton, WA",
  "property_seo_description_home": "Modern apartments near Topgolf in Renton, WA - pet-friendly, with a gym, pool, and easy access to I-405 and Park and Ride.",
  "property_seo_title_floorplans": "Floor plans for Regency Woods apartments in Renton, WA",
  "property_seo_description_floorplans": "Choose from one-, two-, and three-bedroom apartments in Renton, WA - flexible layouts, in-unit laundry, pet-friendly, designed for comfort.",
  "property_seo_title_amenities": "Amenities at Regency Woods apartments in Renton, WA",
  "property_seo_description_amenities": "Enjoy a fitness center, pool, in-home laundry, and stainless steel appliances at Regency Woods in Renton, WA - comfort meets convenience.",
  "property_seo_title_gallery": "Photo gallery of Regency Woods apartments in Renton, WA",
  "property_seo_description_gallery": "Explore photos of Regency Woods in Renton, WA - see modern kitchens, social spaces, and inviting amenities.",
  "property_seo_title_virtualtours": "Regency Woods virtual tour | apartments in Renton, WA",
  "property_seo_description_virtualtours": "Explore Regency Woods apartments in Renton, WA, from anywhere with a convenient online virtual tour option.",
  "property_seo_title_interactivemap": "Interactive Map | Regency Woods Apartments",
  "property_seo_description_interactivemap": "Discover your haven at Regency Woods, Renton, WA! Explore our interactive map for stunning one to three-bedroom apartments. Your new home awaits!",
  "property_seo_title_neighborhood": "Neighborhood near Regency Woods apartments in Renton, WA",
  "property_seo_description_neighborhood": "Discover the best of Renton, WA - Regency Woods puts you near Southcenter Mall, Top Golf, and local parks.",
  "property_seo_title_contact": "Contact Regency Woods apartments in Renton, WA",
  "property_seo_description_contact": "Contact the Regency Woods leasing team in Renton, WA - learn more about floor plans, tours, and current availability.",
  "property_seo_title_faqs": "FAQs | Apartments in Renton, WA",
  "property_seo_description_faqs": "Unlock the answers to your questions at Regency Woods in Renton, WA. Explore our FAQs and discover what makes our community the perfect home!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Renton, WA",
  "property_seo_description_reviews": "Experience community living at Regency Woods in Renton! Explore resident reviews and discover our vibrant lifestyle and unique amenities.",
  "property_seo_title_applynow": "Apply Now | Apartments in Renton, WA",
  "property_seo_description_applynow": "Join Regency Woods in Renton, WA! Choose from spacious 1-3 bedroom layouts with luxury amenities. Lease online today and elevate your lifestyle!",
  "property_seo_title_residentaccess": "Resident Access | Regency Woods",
  "property_seo_description_residentaccess": "Unlock convenience at Regency Woods in Renton, WA! Access your resident portal for effortless rent payments, maintenance requests, and community updates today!",
  "property_seo_title_referafriend": "Refer A Friend | Regency Woods",
  "property_seo_description_referafriend": "Share the joy of Regency Woods! Refer a friend and enjoy exclusive rewards in the heart of Renton, WA. Great friends make great neighbors—join us!",
  "property_seo_title_scheduletour": "Schedule a tour at Regency Woods apartments in Renton, WA",
  "property_seo_description_scheduletour": "Visit Regency Woods in Renton, WA - choose a live virtual or in-person tour to see available floor plans and amenities.",
  "property_seo_title_privacy": "Privacy Policy | Regency Woods",
  "property_seo_description_privacy": "Your privacy matters at Regency Woods. Learn how we protect your personal information while you enjoy life in beautiful Renton, WA. View our privacy policy.",
  "property_seo_title_accessibility": "Website Accessibility | Regency Woods",
  "property_seo_description_accessibility": "At Regency Woods in Renton, WA, we're committed to digital inclusion. Our accessibility statement ensures everyone can enjoy our vibrant community. Join us!",
  "property_seo_title_sitemap": "Sitemap | Regency Woods",
  "property_seo_description_sitemap": "Uncover a world of comfort at Regency Woods in Renton, WA. Navigate our comprehensive sitemap to find your perfect apartment and community amenities today!",
  "property_seo_title_thankyou": "Thank You | Regency Woods",
  "property_seo_description_thankyou": "Thank you for reaching out! A member of our Regency Woods team in Renton, WA will be in touch soon to guide you toward your new home sweet home!",
  "property_seo_title_pets": "Pet Policy | Apartments in Renton, WA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793119463077",
  "amenities": [
    {
      "id": "ec_3174d38f3ea72c32880b7261",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "yardi",
      "external_id": "86812614",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03a85-85c1-7268-b9ce-b8e33eb5c2e7.webp",
      "amenity_image_media": {
        "alt_text": "Fitness center with cardio machines and free weights.",
        "public_id": "01a03a85-85c1-7268-b9ce-b8e33eb5c2e7",
        "storage_key": "property/6767906449167248/01a03a85-85c1-7268-b9ce-b8e33eb5c2e7.webp",
        "width": 1024,
        "height": 682
      },
      "amenity_image_alt_text": "Regency Woods Gym",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_409a3eb761737a6344ab12d7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "yardi",
      "external_id": "86812615",
      "title": "Free Weights",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b1ad1791163f8530517083fe",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "yardi",
      "external_id": "86812616",
      "title": "Seasonal Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03a85-84c1-77bb-bff8-299a7b80102a.webp",
      "amenity_image_media": {
        "alt_text": "Resort-style swimming pool with reflections of apartment buildings and blue sky.",
        "public_id": "01a03a85-84c1-77bb-bff8-299a7b80102a",
        "storage_key": "property/6767906449167248/01a03a85-84c1-77bb-bff8-299a7b80102a.webp",
        "width": 1023,
        "height": 682
      },
      "amenity_image_alt_text": "a swimming pool in front of an apartment building,Regency Woods Pool",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2ee77837fd558a7cdf28f24b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "yardi",
      "external_id": "86812617",
      "title": "Cardio Machines",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03a85-8550-74ca-a3fd-5e64119706cc.webp",
      "amenity_image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, and free weights.",
        "public_id": "01a03a85-8550-74ca-a3fd-5e64119706cc",
        "storage_key": "property/6767906449167248/01a03a85-8550-74ca-a3fd-5e64119706cc.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "the estates at tanglewood|fitness room",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5da7fcea2e5040b9c1d0c282",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "yardi",
      "external_id": "86812618",
      "title": "Weight Machines",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1d86af7cd9a3eae999824f8f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "yardi",
      "external_id": "121277512",
      "title": "Beautiful Landscaping",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_21ffb63ec793a2043b54634b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "yardi",
      "external_id": "121277514",
      "title": "Monthly Resident Events",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b1f2848683c79de4bee983b9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "yardi",
      "external_id": "122049726",
      "title": "Indoor Spa",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b883afc9c2b249a70453613b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "yardi",
      "external_id": "124800119",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_536a06571ef41b94d869b066",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "yardi",
      "external_id": "86812619",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b1f5585206195dff772c0075",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "yardi",
      "external_id": "86812621",
      "title": "Microwave *in select homes only",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b2a0f7678e033aae25461e6f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "yardi",
      "external_id": "86812623",
      "title": "Stainless Steel Kitchen Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d9a3d-8f66-74a8-93a9-64f84e2cd051.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with wood cabinets, granite countertops, and stainless steel appliances including a microwave, oven, and dishwasher.",
        "public_id": "019d9a3d-8f66-74a8-93a9-64f84e2cd051",
        "storage_key": "property/6767906449167248/019d9a3d-8f66-74a8-93a9-64f84e2cd051.webp",
        "width": 1024,
        "height": 682
      },
      "amenity_image_alt_text": "Regency Woods Kitchen",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dcd65e041b1622616592b52d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "yardi",
      "external_id": "86812624",
      "title": "Electric Stove/Range",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d91c4b0c6c3da7793c4c26b6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "yardi",
      "external_id": "86812625",
      "title": "Baseboard Heat, No AC",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_042b2bd8c5d781535b73fca8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "yardi",
      "external_id": "86812626",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_40ab1b8b0cfd0e027a76f8f1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "yardi",
      "external_id": "86812627",
      "title": "Vaulted Ceiling *in select homes only",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_43d60f8bb0d24af04dd473eb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "yardi",
      "external_id": "86812628",
      "title": "Views *in select homes only",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6a7e1cbb17e17755c24dcd68",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "yardi",
      "external_id": "86812629",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03a85-85a3-740d-90ff-c00044427014.webp",
      "amenity_image_media": {
        "alt_text": "Stackable washer and dryer unit in a closet.",
        "public_id": "01a03a85-85a3-740d-90ff-c00044427014",
        "storage_key": "property/6767906449167248/01a03a85-85a3-740d-90ff-c00044427014.webp",
        "width": 1024,
        "height": 682
      },
      "amenity_image_alt_text": "Regency Woods Laundry",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9c8b1701e03138f93e6c59b6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "yardi",
      "external_id": "86812633",
      "title": "Linen Closet *in select homes only",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0d68e49447ba49c6da591c80",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "yardi",
      "external_id": "86812622",
      "title": "Granite Kitchen Countertops *in select homes only",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_92061578795ab0018fc6d829",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "yardi",
      "external_id": "86812630",
      "title": "Built-In Bookshelves *in select homes only",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_450a8d94b982bd266abd9113",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "yardi",
      "external_id": "86812631",
      "title": "Built-In Office/Desk *in select homes only",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_47ecf2ad9b171ddf9da2cb2c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "yardi",
      "external_id": "86812632",
      "title": "Dining Room",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8ca4d7e456ae47a119439d01",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "yardi",
      "external_id": "86812635",
      "title": "Sprinkler System *in select homes only",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_43216e04f4df63e522dcc9fa",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
      "image_media": {
        "alt_text": "Exterior view of a large apartment building with a distinctive turret.",
        "public_id": "01a03a7d-b3cf-7000-8a2c-f9640733cae5",
        "storage_key": "property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Community",
      "description": "Captivating exterior view of the apartment building, featuring a unique turret and expansive green lawns.",
      "link": "false",
      "alt_text": "Exterior view of a large apartment building with a distinctive turret.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Regency_Woods_Favorites (49).jpg"
    },
    {
      "id": "ec_f3e646103c2e2c0662a2f3c3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a046ed-bd12-74eb-a9f1-a3c098189622.webp",
      "image_media": {
        "alt_text": "Up to one month free on select homes promotion",
        "public_id": "01a046ed-bd12-74eb-a9f1-a3c098189622",
        "storage_key": "property/6767906449167248/01a046ed-bd12-74eb-a9f1-a3c098189622.webp",
        "width": 1084,
        "height": 684
      },
      "title": "Other",
      "description": "Special offer: Get up to one month free on select homes. Restrictions apply. Specials, pricing and availability subject to change daily. Contact the leasing office for details.",
      "link": "false",
      "alt_text": "Up to one month free on select homes promotion",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/Copy of Copy of Move In Specials (4).png"
    },
    {
      "id": "ec_cf5a8819f22d7bc611017d71",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03a7d-f01e-7009-90e5-bce6925224a9.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and spa area with adjacent apartment buildings.",
        "public_id": "01a03a7d-f01e-7009-90e5-bce6925224a9",
        "storage_key": "property/6767906449167248/01a03a7d-f01e-7009-90e5-bce6925224a9.webp",
        "width": 3072,
        "height": 2043
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling outdoor pool and relax in the adjacent spa. The perfect place to unwind and soak up the sun.",
      "link": "false",
      "alt_text": "Outdoor swimming pool and spa area with adjacent apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Regency_Woods_Favorites (50).jpg"
    },
    {
      "id": "ec_6d0e6d4b629079ae8d17ba0c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03a7d-e998-774d-b366-db5429b4df78.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with reflections of the apartment building under a blue sky with clouds.",
        "public_id": "01a03a7d-e998-774d-b366-db5429b4df78",
        "storage_key": "property/6767906449167248/01a03a7d-e998-774d-b366-db5429b4df78.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our resort-style outdoor pool, a perfect oasis for relaxation and fun under the sun.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with reflections of the apartment building under a blue sky with clouds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Regency_Woods_Favorites (42).jpg"
    },
    {
      "id": "ec_f2d23b9d99bbf5eb943f783e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03a7d-dc53-712c-a795-f9ba3ef419d3.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and hot tub with lounge chairs and yellow umbrellas.",
        "public_id": "01a03a7d-dc53-712c-a795-f9ba3ef419d3",
        "storage_key": "property/6767906449167248/01a03a7d-dc53-712c-a795-f9ba3ef419d3.webp",
        "width": 3072,
        "height": 1733
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool or relax in the soothing hot tub. Lounge chairs and umbrellas provide the perfect spot to soak up the sun.",
      "link": "false",
      "alt_text": "Outdoor swimming pool and hot tub with lounge chairs and yellow umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Regency_Woods_Favorites (27).jpg"
    },
    {
      "id": "ec_6c2088b2fa8e474b536d7fde",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03a7d-f000-77ba-a34e-0f514cae482a.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and trees.",
        "public_id": "01a03a7d-f000-77ba-a34e-0f514cae482a",
        "storage_key": "property/6767906449167248/01a03a7d-f000-77ba-a34e-0f514cae482a.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Beautifully maintained apartment buildings with private balconies and lush green surroundings, offering a serene living environment.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with balconies and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Regency_Woods_Favorites (44).jpg"
    },
    {
      "id": "ec_c7a1f4576a866f7d3eddc1b1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03a7e-01f6-7089-998c-6a165b191ab4.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and surrounding trees.",
        "public_id": "01a03a7e-01f6-7089-998c-6a165b191ab4",
        "storage_key": "property/6767906449167248/01a03a7e-01f6-7089-998c-6a165b191ab4.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "View of the apartment buildings' exteriors, showcasing balconies, windows, and lush greenery.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with balconies and surrounding trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Regency_Woods_Favorites (47).jpg"
    },
    {
      "id": "ec_2a6ade204fab829bfc39d766",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03a7e-1114-7153-a332-bbb2a761c332.webp",
      "image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with balconies and surrounding green lawn and trees.",
        "public_id": "01a03a7e-1114-7153-a332-bbb2a761c332",
        "storage_key": "property/6767906449167248/01a03a7e-1114-7153-a332-bbb2a761c332.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Discover comfortable living at our apartment community, featuring well-maintained exteriors and beautiful natural surroundings. Enjoy the convenience of balconies and ample green space.",
      "link": "false",
      "alt_text": "Exterior view of a multi-story apartment building with balconies and surrounding green lawn and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Regency_Woods_Favorites (37).jpg"
    },
    {
      "id": "ec_5cf74f6eb2999e79351e2718",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03a7e-1ac8-735d-984a-4ca7381ad024.webp",
      "image_media": {
        "alt_text": "Living room with a stone fireplace, comfortable seating, and a desk.",
        "public_id": "01a03a7e-1ac8-735d-984a-4ca7381ad024",
        "storage_key": "property/6767906449167248/01a03a7e-1ac8-735d-984a-4ca7381ad024.webp",
        "width": 3072,
        "height": 1733
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a beautiful stone fireplace, plush seating areas, and a functional workspace, perfect for relaxing or working from home.",
      "link": "false",
      "alt_text": "Living room with a stone fireplace, comfortable seating, and a desk.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Regency_Woods_Favorites (28).jpg"
    },
    {
      "id": "ec_ec3504fa46b1c7eeb68b0f33",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03a7e-349b-7232-ae69-8c4f09133135.webp",
      "image_media": {
        "alt_text": "Office space with desk, chairs, and fireplace.",
        "public_id": "01a03a7e-349b-7232-ae69-8c4f09133135",
        "storage_key": "property/6767906449167248/01a03a7e-349b-7232-ae69-8c4f09133135.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "This comfortable office space features a large wooden desk, plush seating, and a cozy stone fireplace. Perfect for meetings or a quiet workspace.",
      "link": "false",
      "alt_text": "Office space with desk, chairs, and fireplace.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Regency_Woods_Favorites (38).jpg"
    },
    {
      "id": "ec_44d39c7666c4d51f18c320dc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03a7e-2778-74b8-8a13-83d79e1f1f05.webp",
      "image_media": {
        "alt_text": "Living room and dining area with sofa, ottoman, dining table and chairs.",
        "public_id": "01a03a7e-2778-74b8-8a13-83d79e1f1f05",
        "storage_key": "property/6767906449167248/01a03a7e-2778-74b8-8a13-83d79e1f1f05.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living room and dining area featuring a comfortable sofa, ottoman, and a dining table with chairs. Perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "Living room and dining area with sofa, ottoman, dining table and chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Regency_Woods_Favorites (43).jpg"
    },
    {
      "id": "ec_3cbb9c0ced76b5791a594d8a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03a7e-3d00-749d-83e3-67be3c4ae2a9.webp",
      "image_media": {
        "alt_text": "Playground with slides and climbing structures.",
        "public_id": "01a03a7e-3d00-749d-83e3-67be3c4ae2a9",
        "storage_key": "property/6767906449167248/01a03a7e-3d00-749d-83e3-67be3c4ae2a9.webp",
        "width": 3072,
        "height": 1730
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at the community playground, featuring slides and climbing structures for children.",
      "link": "false",
      "alt_text": "Playground with slides and climbing structures.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Regency_Woods_Favorites (41).jpg"
    },
    {
      "id": "ec_299df65098b0b0d4056ea9f6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03a7e-4bb5-710e-9782-e95739aa07a6.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, free weights, and a bench.",
        "public_id": "01a03a7e-4bb5-710e-9782-e95739aa07a6",
        "storage_key": "property/6767906449167248/01a03a7e-4bb5-710e-9782-e95739aa07a6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our well-equipped fitness center, featuring cardio machines and free weights for a complete workout.",
      "link": "false",
      "alt_text": "Fitness center with treadmills, ellipticals, free weights, and a bench.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Regency_Woods_Favorites (45).jpg"
    },
    {
      "id": "ec_4ea76acf575a78eb64b8689b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03a7e-4cd1-74ca-8c02-c62c0200a8e1.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, bedside tables, lamps, and large windows with blinds.",
        "public_id": "01a03a7e-4cd1-74ca-8c02-c62c0200a8e1",
        "storage_key": "property/6767906449167248/01a03a7e-4cd1-74ca-8c02-c62c0200a8e1.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "A well-appointed bedroom featuring a comfortable queen-size bed, elegant bedside tables with lamps, and large windows that let in natural light.",
      "link": "false",
      "alt_text": "Cozy bedroom with a queen-size bed, bedside tables, lamps, and large windows with blinds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Regency_Woods_Favorites (51).jpg"
    },
    {
      "id": "ec_db6fff0c213f8fb5658228e8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03a7e-6665-74fc-945a-d198de279625.webp",
      "image_media": {
        "alt_text": "Living room with sofa, two chairs, coffee table, and large window.",
        "public_id": "01a03a7e-6665-74fc-945a-d198de279625",
        "storage_key": "property/6767906449167248/01a03a7e-6665-74fc-945a-d198de279625.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sofa, two accent chairs, and a modern coffee table, with natural light streaming through a large sliding glass door.",
      "link": "false",
      "alt_text": "Living room with sofa, two chairs, coffee table, and large window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Regency_Woods_Favorites (46).jpg"
    },
    {
      "id": "ec_c68cb7bb0fed2e331b01fd63",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03a7e-7a8c-769a-b194-a85026b61959.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, two nightstands, and decorative wall art.",
        "public_id": "01a03a7e-7a8c-769a-b194-a85026b61959",
        "storage_key": "property/6767906449167248/01a03a7e-7a8c-769a-b194-a85026b61959.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A beautifully appointed bedroom featuring a queen-size bed with plush bedding, elegant nightstands, and tasteful wall art. Perfect for relaxation and comfort.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, two nightstands, and decorative wall art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Regency_Woods_Favorites (33).jpg"
    },
    {
      "id": "ec_d9236ffacf8696770dd3631a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03a7e-8e11-736d-8c0f-b741977feed5.webp",
      "image_media": {
        "alt_text": "Interior view of a closet with clothing on hangers and shoes on the floor.",
        "public_id": "01a03a7e-8e11-736d-8c0f-b741977feed5",
        "storage_key": "property/6767906449167248/01a03a7e-8e11-736d-8c0f-b741977feed5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Organized closet space with clothing and shoes, ready for your personal touch.",
      "link": "false",
      "alt_text": "Interior view of a closet with clothing on hangers and shoes on the floor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Regency_Woods_Favorites (40).jpg"
    },
    {
      "id": "ec_de3a19ca99402eb82d2f670f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03a7e-87e8-753e-881b-1b170725b046.webp",
      "image_media": {
        "alt_text": "Kitchen with wooden cabinets, granite countertops, stainless steel appliances, and a window.",
        "public_id": "01a03a7e-87e8-753e-881b-1b170725b046",
        "storage_key": "property/6767906449167248/01a03a7e-87e8-753e-881b-1b170725b046.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A well-lit kitchen featuring modern stainless steel appliances, ample wooden cabinetry, and granite countertops, perfect for any home chef.",
      "link": "false",
      "alt_text": "Kitchen with wooden cabinets, granite countertops, stainless steel appliances, and a window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Regency_Woods_Favorites (39).jpg"
    },
    {
      "id": "ec_778b0c345b9626d732a9d093",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03a7e-9082-730d-9fcf-3b8b7054d220.webp",
      "image_media": {
        "alt_text": "Clean and functional bathroom with white bathtub, shower, toilet, and vanity with granite countertop.",
        "public_id": "01a03a7e-9082-730d-9fcf-3b8b7054d220",
        "storage_key": "property/6767906449167248/01a03a7e-9082-730d-9fcf-3b8b7054d220.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy the convenience and comfort of this well-appointed bathroom, featuring a full tub and shower combination, a spacious vanity with granite countertops, and ample lighting.",
      "link": "false",
      "alt_text": "Clean and functional bathroom with white bathtub, shower, toilet, and vanity with granite countertop.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Regency_Woods_Favorites (35).jpg"
    },
    {
      "id": "ec_09eefcda2fc289ad91f37212",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03a7e-9bb9-7648-999c-20b7ba836121.webp",
      "image_media": {
        "alt_text": "Kitchen with stainless steel appliances, granite countertops, and wood cabinets.",
        "public_id": "01a03a7e-9bb9-7648-999c-20b7ba836121",
        "storage_key": "property/6767906449167248/01a03a7e-9bb9-7648-999c-20b7ba836121.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring stainless steel appliances, granite countertops, and ample cabinet space for all your culinary needs.",
      "link": "false",
      "alt_text": "Kitchen with stainless steel appliances, granite countertops, and wood cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Regency_Woods_Favorites (34).jpg"
    },
    {
      "id": "ec_896c988f9399fc8db4aff290",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03a7e-acf9-7259-889c-4f8a2cb1fc13.webp",
      "image_media": {
        "alt_text": "Kitchen with island seating and stainless steel appliances.",
        "public_id": "01a03a7e-acf9-7259-889c-4f8a2cb1fc13",
        "storage_key": "property/6767906449167248/01a03a7e-acf9-7259-889c-4f8a2cb1fc13.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring a breakfast bar with seating, stainless steel appliances, and ample cabinet space.",
      "link": "false",
      "alt_text": "Kitchen with island seating and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Regency_Woods_Favorites (36).jpg"
    },
    {
      "id": "ec_21cf79ac5b87a0f88e1c99c6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03a7e-c97b-738c-80d8-49af178b5f4c.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with a couch, chairs, coffee table, and kitchen counter.",
        "public_id": "01a03a7e-c97b-738c-80d8-49af178b5f4c",
        "storage_key": "property/6767906449167248/01a03a7e-c97b-738c-80d8-49af178b5f4c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living room and kitchen area featuring a comfortable seating arrangement and a granite-top breakfast bar.",
      "link": "false",
      "alt_text": "Living room and kitchen area with a couch, chairs, coffee table, and kitchen counter.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Regency_Woods_Favorites (32).jpg"
    },
    {
      "id": "ec_a81fb9c4b8d682d3facb944e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03a7e-c7e6-726a-b88d-64623b359d1c.webp",
      "image_media": {
        "alt_text": "Bathroom with a granite countertop, sink, toilet, and a bathtub with a shower curtain.",
        "public_id": "01a03a7e-c7e6-726a-b88d-64623b359d1c",
        "storage_key": "property/6767906449167248/01a03a7e-c7e6-726a-b88d-64623b359d1c.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "A clean and well-lit bathroom featuring a granite vanity with a sink, a toilet, and a bathtub with a decorative shower curtain.",
      "link": "false",
      "alt_text": "Bathroom with a granite countertop, sink, toilet, and a bathtub with a shower curtain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Regency_Woods_Favorites (31).jpg"
    },
    {
      "id": "ec_6111c01e3e499d0839406cdc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03a7e-d1a1-744d-b381-f196adc72667.webp",
      "image_media": {
        "alt_text": "Kitchen with stainless steel appliances, granite countertops, and light wood cabinets.",
        "public_id": "01a03a7e-d1a1-744d-b381-f196adc72667",
        "storage_key": "property/6767906449167248/01a03a7e-d1a1-744d-b381-f196adc72667.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring a stainless steel range, microwave, and refrigerator, complemented by granite countertops and ample cabinet space.",
      "link": "false",
      "alt_text": "Kitchen with stainless steel appliances, granite countertops, and light wood cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Regency_Woods_Favorites (30).jpg"
    },
    {
      "id": "ec_01f4bbf74fa447a24d9b844e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03a7e-cd0d-754f-8350-5a80f211e276.webp",
      "image_media": {
        "alt_text": "Stackable washer and dryer unit inside a closet.",
        "public_id": "01a03a7e-cd0d-754f-8350-5a80f211e276",
        "storage_key": "property/6767906449167248/01a03a7e-cd0d-754f-8350-5a80f211e276.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Convenient in-unit stackable washer and dryer for your laundry needs.",
      "link": "false",
      "alt_text": "Stackable washer and dryer unit inside a closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Regency_Woods_Favorites (29).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_c5cd4e60-4b9e-4f5e-a45a-06c66a639380",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Countryside Cafe",
      "poi_type": "Restaurants",
      "poi_address": "4004 NE 4th St #101, Renton, WA 98056, USA",
      "poi_short_description": "Generous plates of traditional American fare & breakfast all day are the draw at this casual eatery.",
      "poi_long_description": "Generous plates of traditional American fare & breakfast all day are the draw at this casual eatery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed5-0f66-723c-8037-947caa81d160.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed5-0f66-723c-8037-947caa81d160",
        "storage_key": "property/6767906449167248/01a03ed5-0f66-723c-8037-947caa81d160.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "http://www.countrysidecafewa.com/welcome",
      "poi_directions_map_url": "https://maps.google.com/?cid=10787565915554786771&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "countryside-cafe",
      "poi_latitude": "47.4888942",
      "poi_longitude": "-122.1658234",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 425-255-3595",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-74ef-7377-89e5-e26386cf2902.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-74ef-7377-89e5-e26386cf2902",
        "storage_key": "property/6767906449167248/019d0229-74ef-7377-89e5-e26386cf2902.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJEaL0I99nkFQR0y3BkwsitZU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_0ace405f-b676-4de4-a905-c6ae5f455308",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Boon Boona Coffee",
      "poi_type": "Restaurants",
      "poi_address": "724 S 3rd St, Renton, WA 98057, USA",
      "poi_short_description": "Cozy cafe featuring coffee, teas, breakfast sandwiches, and pastries, plus Wi-Fi.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed5-145b-717b-9beb-03ddf99d1281.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed5-145b-717b-9beb-03ddf99d1281",
        "storage_key": "property/6767906449167248/01a03ed5-145b-717b-9beb-03ddf99d1281.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.boonboonacoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2151110976658883656&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boon-boona-coffee",
      "poi_latitude": "47.4797895",
      "poi_longitude": "-122.2069431",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 425-496-8618",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-74ef-7377-89e5-e26386cf2902.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-74ef-7377-89e5-e26386cf2902",
        "storage_key": "property/6767906449167248/019d0229-74ef-7377-89e5-e26386cf2902.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJD_A6aqtCkFQRSEQyRAlI2h0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_73fd5d09-910b-43bf-84c5-d4574c50102c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Top Pot Doughnuts",
      "poi_type": "Restaurants",
      "poi_address": "815 N 10th St F, Renton, WA 98057, USA",
      "poi_short_description": "Local chain outpost serving handmade donuts & house-roasted coffee in a casual yet stylish space.",
      "poi_long_description": "Local chain outpost serving handmade donuts & house-roasted coffee in a casual yet stylish space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed5-0ff6-7533-8fed-863de20aef4d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed5-0ff6-7533-8fed-863de20aef4d",
        "storage_key": "property/6767906449167248/01a03ed5-0ff6-7533-8fed-863de20aef4d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.toppotdoughnuts.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6003145307665827262&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "top-pot-doughnuts",
      "poi_latitude": "47.497585",
      "poi_longitude": "-122.204492",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 425-291-7483",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-7534-76e5-b963-eb411407422c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-7534-76e5-b963-eb411407422c",
        "storage_key": "property/6767906449167248/019d0229-7534-76e5-b963-eb411407422c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJt0ZBzxlokFQRvoV57tl0T1M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "donut_shop"
    },
    {
      "id": "custom_67bb6749-13b0-4993-8776-8df2c16839d6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Dough Zone Dumpling House Renton Landing",
      "poi_type": "Restaurants",
      "poi_address": "800 N 10th Pl Ste A, Renton, WA 98057, USA",
      "poi_short_description": "Casual, modern spot for dumplings (steamed, fried) and other Chinese eats (such as dim sum, steamed buns, pot stickers, green onion pancakes and noodle soup).",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed5-0f9a-7781-83a4-5844a279029f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed5-0f9a-7781-83a4-5844a279029f",
        "storage_key": "property/6767906449167248/01a03ed5-0f9a-7781-83a4-5844a279029f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.doughzonedumplinghouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4315815839764686832&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dough-zone-dumpling-house-renton-landing",
      "poi_latitude": "47.4980072",
      "poi_longitude": "-122.2048259",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 425-227-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-7534-76e5-b963-eb411407422c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-7534-76e5-b963-eb411407422c",
        "storage_key": "property/6767906449167248/019d0229-7534-76e5-b963-eb411407422c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-WX3BgZpkFQR8Kct3aPb5Ds",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_restaurant"
    },
    {
      "id": "custom_1d46de1d-7715-427c-b2aa-17939f6de045",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Pho Asia Noodle House Renton",
      "poi_type": "Restaurants",
      "poi_address": "801 S 3rd St, Renton, WA 98057, USA",
      "poi_short_description": "Casual, family-owned eatery serving pho, rice and vermicelli dishes, as well as some familiar favorites.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed5-1456-704a-ae93-14cee42798f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed5-1456-704a-ae93-14cee42798f2",
        "storage_key": "property/6767906449167248/01a03ed5-1456-704a-ae93-14cee42798f2.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "http://phoasiarenton.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=825060627400596277&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pho-asia-noodle-house-renton",
      "poi_latitude": "47.4796029",
      "poi_longitude": "-122.2065171",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 425-204-9991",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-7534-76e5-b963-eb411407422c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-7534-76e5-b963-eb411407422c",
        "storage_key": "property/6767906449167248/019d0229-7534-76e5-b963-eb411407422c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJO7q8As5DkFQRNZtf7kQ0cws",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "vietnamese_restaurant"
    },
    {
      "id": "custom_c47a0851-9685-42be-83c1-1c6ba17f5f77",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Torero's Cocina Mexicana & Cantina - Renton",
      "poi_type": "Restaurants",
      "poi_address": "920 N 10th St, Renton, WA 98057, USA",
      "poi_short_description": "Classic Mexican food such as tacos & burritos, plus flavored margaritas, served in a casual setting.",
      "poi_long_description": "Classic Mexican food such as tacos & burritos, plus flavored margaritas, served in a casual setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-1097-77f0-81c2-085fecebdd1a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-1097-77f0-81c2-085fecebdd1a",
        "storage_key": "property/6767906449167248/019d0229-1097-77f0-81c2-085fecebdd1a.webp",
        "width": 1080,
        "height": 1080
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16721763250542249005&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "toreros-cocina-mexicana--cantina---renton",
      "poi_latitude": "47.4980978",
      "poi_longitude": "-122.2025685",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 425-228-6180",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-7534-76e5-b963-eb411407422c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-7534-76e5-b963-eb411407422c",
        "storage_key": "property/6767906449167248/019d0229-7534-76e5-b963-eb411407422c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJY8PLhrJCkFQRLYTAphSjD-g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_72cfc0f4-25f7-486b-b9d3-b3309d491b32",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Vino at the Landing",
      "poi_type": "Restaurants",
      "poi_address": "800 N 10th Pl, Renton, WA 98057, USA",
      "poi_short_description": "Wine bar & retail store serving small plates & mostly local wines in a bright room with a fireplace.",
      "poi_long_description": "Wine bar & retail store serving small plates & mostly local wines in a bright room with a fireplace.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-1252-7665-b60b-1f51eb13a95f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-1252-7665-b60b-1f51eb13a95f",
        "storage_key": "property/6767906449167248/019d0229-1252-7665-b60b-1f51eb13a95f.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "https://www.vinoatthelanding.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16605785018984541108&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vino-at-the-landing",
      "poi_latitude": "47.4980556",
      "poi_longitude": "-122.2047222",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 425-282-0382",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-7535-71dc-acb6-95a0e7a7d037.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-7535-71dc-acb6-95a0e7a7d037",
        "storage_key": "property/6767906449167248/019d0229-7535-71dc-acb6-95a0e7a7d037.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_VhdzRlokFQRtKsTWX6Zc-Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wine_bar"
    },
    {
      "id": "custom_3ae64e6e-4330-4865-bd7c-f201885c2fda",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Mori Sushi & Grill by Aji",
      "poi_type": "Restaurants",
      "poi_address": "840 N 10th Pl Ste D, Renton, WA 98057, USA",
      "poi_short_description": "Sushi restaurant in The Landing offering small plates and beer in a casual atmosphere.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-0c47-73e6-8ca1-83021ff7c734.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-0c47-73e6-8ca1-83021ff7c734",
        "storage_key": "property/6767906449167248/019d0229-0c47-73e6-8ca1-83021ff7c734.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://ajimori.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18129477170110407759&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mori-sushi--grill-by-aji",
      "poi_latitude": "47.4985201",
      "poi_longitude": "-122.203554",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 425-572-6452",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-7534-76e5-b963-eb411407422c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-7534-76e5-b963-eb411407422c",
        "storage_key": "property/6767906449167248/019d0229-7534-76e5-b963-eb411407422c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJz4bHI3lpkFQRTyT8n27XmPs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_12e4e11e-4d3f-4ee4-b49b-411eb498610f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Marianna Ristorante",
      "poi_type": "Restaurants",
      "poi_address": "310 Wells Ave S, Renton, WA 98057, USA",
      "poi_short_description": "Classic Italian comfort food served in a warm, laid-back setting with a full bar.",
      "poi_long_description": "Classic Italian comfort food served in a warm, laid-back setting with a full bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-1a3b-7420-a378-f1b978850880.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-1a3b-7420-a378-f1b978850880",
        "storage_key": "property/6767906449167248/019d0229-1a3b-7420-a378-f1b978850880.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://mariannarenton.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13788673992232720617&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marianna-ristorante",
      "poi_latitude": "47.4792433",
      "poi_longitude": "-122.2051971",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 425-961-6517",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-7534-76e5-b963-eb411407422c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-7534-76e5-b963-eb411407422c",
        "storage_key": "property/6767906449167248/019d0229-7534-76e5-b963-eb411407422c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwxBfNqtCkFQR6diyvvA1W78",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_97d73e2d-176f-4388-bee4-4e275496c902",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Vince's Italian Restaurant & Pizzeria",
      "poi_type": "Restaurants",
      "poi_address": "2815 NE Sunset Blvd, Renton, WA 98056, USA",
      "poi_short_description": "Relaxed joint for hand-tossed, brick-oven pizzas, plus other Mediterranean standards.",
      "poi_long_description": "Relaxed joint for hand-tossed, brick-oven pizzas, plus other Mediterranean standards.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed5-14be-76e8-ad29-4342b1b14cb5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed5-14be-76e8-ad29-4342b1b14cb5",
        "storage_key": "property/6767906449167248/01a03ed5-14be-76e8-ad29-4342b1b14cb5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.vincesrestaurants.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13403491949540077598&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vinces-italian-restaurant--pizzeria",
      "poi_latitude": "47.50052",
      "poi_longitude": "-122.178029",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 425-226-8180",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-7534-76e5-b963-eb411407422c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-7534-76e5-b963-eb411407422c",
        "storage_key": "property/6767906449167248/019d0229-7534-76e5-b963-eb411407422c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJR149tW1okFQRHvAk0unEAro",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_708940ba-8a63-44dd-8aa1-8d613e8bb3f5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Sing Tong Thai Cuisine and Bar",
      "poi_type": "Restaurants",
      "poi_address": "4605 NE 4th St #1-2, Renton, WA 98059, USA",
      "poi_short_description": "Thai classics & cocktails served in a casual, well appointed setting with faux palms & a warm vibe .",
      "poi_long_description": "Thai classics & cocktails served in a casual, well appointed setting with faux palms & a warm vibe .",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed5-1cf6-7258-bc34-5abfebb87f87.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed5-1cf6-7258-bc34-5abfebb87f87",
        "storage_key": "property/6767906449167248/01a03ed5-1cf6-7258-bc34-5abfebb87f87.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.singtongthai.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10642204083558779401&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sing-tong-thai-cuisine-and-bar",
      "poi_latitude": "47.4883173",
      "poi_longitude": "-122.1572889",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 425-524-4910",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-7534-76e5-b963-eb411407422c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-7534-76e5-b963-eb411407422c",
        "storage_key": "property/6767906449167248/019d0229-7534-76e5-b963-eb411407422c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJg0YyKNpnkFQRCYq7qzq0sJM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "custom_886a2110-effa-4c94-9152-456fd5ede0ec",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "El Recreo",
      "poi_type": "Restaurants",
      "poi_address": "2801 NE Sunset Blvd Ste A, Renton, WA 98056, USA",
      "poi_short_description": "Tacos, tortas, quesadillas, and other familiar Mexican dishes in a no-frills setting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed5-1bb7-71fa-995b-01f59cc7830f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed5-1bb7-71fa-995b-01f59cc7830f",
        "storage_key": "property/6767906449167248/01a03ed5-1bb7-71fa-995b-01f59cc7830f.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.orderelrecreowa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2254767757207716060&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-recreo",
      "poi_latitude": "47.4999304",
      "poi_longitude": "-122.1799763",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 425-572-6136",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-7534-76e5-b963-eb411407422c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-7534-76e5-b963-eb411407422c",
        "storage_key": "property/6767906449167248/019d0229-7534-76e5-b963-eb411407422c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJH8kxY61pkFQR3MBeM1SLSh8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_25de4a84-a819-4e1c-922a-68fede6371d3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Dubtown Brewing Company",
      "poi_type": "Restaurants",
      "poi_address": "201 Main Ave S, Renton, WA 98057, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed5-1c0b-76d7-a06b-1d6cee381533.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed5-1c0b-76d7-a06b-1d6cee381533",
        "storage_key": "property/6767906449167248/01a03ed5-1c0b-76d7-a06b-1d6cee381533.webp",
        "width": 1039,
        "height": 585
      },
      "poi_business_url": "https://dubtownbrewingcompany.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=122555422655681721&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dubtown-brewing-company",
      "poi_latitude": "47.480922",
      "poi_longitude": "-122.2044723",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 425-207-8707",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-7842-761d-ab2e-574f32d440a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-7842-761d-ab2e-574f32d440a7",
        "storage_key": "property/6767906449167248/019d0229-7842-761d-ab2e-574f32d440a7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBXqiqQdDkFQRuZSw8IFnswE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "custom_a42e7c3c-ec53-4ac0-9dc3-da0eba25f0cd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Bindaas Indian Restaurant Sports Bar & Dukaan",
      "poi_type": "Restaurants",
      "poi_address": "811 S 3rd St, Renton, WA 98057, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed5-1a19-7692-aa8c-affef6159599.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed5-1a19-7692-aa8c-affef6159599",
        "storage_key": "property/6767906449167248/01a03ed5-1a19-7692-aa8c-affef6159599.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://bindaasrenton.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11428306140943024735&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bindaas-indian-restaurant-sports-bar--dukaan",
      "poi_latitude": "47.47949089999999",
      "poi_longitude": "-122.2058927",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 425-528-7133",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-7534-76e5-b963-eb411407422c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-7534-76e5-b963-eb411407422c",
        "storage_key": "property/6767906449167248/019d0229-7534-76e5-b963-eb411407422c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJm5uSRwBDkFQRXwJTq-J_mZ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indian_restaurant"
    },
    {
      "id": "custom_4fe97677-dd73-4c35-8455-cb55dc82c6b1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Mi Casa Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "17174 116th Ave SE, Renton, WA 98058, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed5-1db3-76a9-9247-65e7a9eb6403.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed5-1db3-76a9-9247-65e7a9eb6403",
        "storage_key": "property/6767906449167248/01a03ed5-1db3-76a9-9247-65e7a9eb6403.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14332531596939467912&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mi-casa-market",
      "poi_latitude": "47.4493241",
      "poi_longitude": "-122.1856891",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 425-793-4039",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-7535-71dc-acb6-9bcb4952574e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-7535-71dc-acb6-9bcb4952574e",
        "storage_key": "property/6767906449167248/019d0229-7535-71dc-acb6-9bcb4952574e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyRdICnFdkFQRiJyj54xh58Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_566ef60e-53c0-43e6-aa48-fe2279b2d2ac",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "275 Rainier Ave S Walgreens, Renton, WA 98057, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed5-2821-77cf-8d23-c38fd21a825b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed5-2821-77cf-8d23-c38fd21a825b",
        "storage_key": "property/6767906449167248/01a03ed5-2821-77cf-8d23-c38fd21a825b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-275+rainier+ave+s-renton-wa-98057/id=4627",
      "poi_directions_map_url": "https://maps.google.com/?cid=15437320617434527976&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "47.4802915",
      "poi_longitude": "-122.2180606",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 425-277-0212",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-7842-761d-ab2e-574f32d440a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-7842-761d-ab2e-574f32d440a7",
        "storage_key": "property/6767906449167248/019d0229-7842-761d-ab2e-574f32d440a7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgVM4Cq5CkFQR6Lj_pU9hPNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_5ddbdb00-3f3a-44cf-969d-785310e111d8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "17615 108th Ave SE, Renton, WA 98055, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed5-1e69-7174-b82f-90d2b14e4a43.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed5-1e69-7174-b82f-90d2b14e4a43",
        "storage_key": "property/6767906449167248/01a03ed5-1e69-7174-b82f-90d2b14e4a43.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.7-eleven.com/locations/wa/renton/17615-108th-ave-35056?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=9841413172019579563&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "47.44472409999999",
      "poi_longitude": "-122.1975052",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 425-226-0078",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-785b-772e-bed5-882281c100a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-785b-772e-bed5-882281c100a0",
        "storage_key": "property/6767906449167248/019d0229-785b-772e-bed5-882281c100a0.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJN70t9gxdkFQRq8oTTiO5k4g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_89adec7b-469b-4f72-8ddc-82bd36259ab8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Grocery Outlet",
      "poi_type": "Shopping & Retail",
      "poi_address": "2809 NE Sunset Blvd, Renton, WA 98056, USA",
      "poi_short_description": "Discount chain carrying brand-name groceries, plus items like gifts & toys (many sell beer & wine).",
      "poi_long_description": "Discount chain carrying brand-name groceries, plus items like gifts & toys (many sell beer & wine).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed5-212f-7556-a9f3-f87683e13c68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed5-212f-7556-a9f3-f87683e13c68",
        "storage_key": "property/6767906449167248/01a03ed5-212f-7556-a9f3-f87683e13c68.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "https://www.groceryoutlet.com/circulars/storeid/101",
      "poi_directions_map_url": "https://maps.google.com/?cid=15899291398578886795&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grocery-outlet",
      "poi_latitude": "47.5004237",
      "poi_longitude": "-122.1792911",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 425-988-2515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-7535-71dc-acb6-9bcb4952574e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-7535-71dc-acb6-9bcb4952574e",
        "storage_key": "property/6767906449167248/019d0229-7535-71dc-acb6-9bcb4952574e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO6N4zW1okFQRi9i3-Emhpdw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_908836b0-bb54-4580-8c6a-46347a703b5c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Viet-Wah Asian Food Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "2825 NE Sunset Blvd, Renton, WA 98056, USA",
      "poi_short_description": "Sizeable grocery store chain stocking Asian provisions, including meat, fish & produce.",
      "poi_long_description": "Sizeable grocery store chain stocking Asian provisions, including meat, fish & produce.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed5-1f4c-735e-9d5d-b278a0d7a46e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed5-1f4c-735e-9d5d-b278a0d7a46e",
        "storage_key": "property/6767906449167248/01a03ed5-1f4c-735e-9d5d-b278a0d7a46e.webp",
        "width": 1280,
        "height": 841
      },
      "poi_business_url": "http://www.vietwah.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17257131958244474208&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "viet-wah-asian-food-market",
      "poi_latitude": "47.5014859",
      "poi_longitude": "-122.1781076",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 425-336-6888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-7535-71dc-acb6-9bcb4952574e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-7535-71dc-acb6-9bcb4952574e",
        "storage_key": "property/6767906449167248/019d0229-7535-71dc-acb6-9bcb4952574e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0Uk5NWxokFQRYP0zdRWmfe8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_df4967e5-d936-4062-b7ed-56345cac7fbc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Fred Meyer",
      "poi_type": "Shopping & Retail",
      "poi_address": "365 Renton Center Way SW, Renton, WA 98057, USA",
      "poi_short_description": "Longtime retail chain for groceries, apparel & furniture, plus toys, electronics, housewares & more.",
      "poi_long_description": "Longtime retail chain for groceries, apparel & furniture, plus toys, electronics, housewares & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-1f17-73d2-be59-77d0e8b009cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-1f17-73d2-be59-77d0e8b009cd",
        "storage_key": "property/6767906449167248/019d0229-1f17-73d2-be59-77d0e8b009cd.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.fredmeyer.com/stores/grocery/wa/renton/renton/701/00459?cid=loc_70100459_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=14328963255089438388&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fred-meyer",
      "poi_latitude": "47.4773474",
      "poi_longitude": "-122.2190404",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 425-204-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-7535-71dc-acb6-9bcb4952574e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-7535-71dc-acb6-9bcb4952574e",
        "storage_key": "property/6767906449167248/019d0229-7535-71dc-acb6-9bcb4952574e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg5wYWbJCkFQRtB47kym02sY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_63247ef5-ac22-44ae-9ff3-3a7de4e16d68",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Safeway",
      "poi_type": "Shopping & Retail",
      "poi_address": "17230 140th Ave SE, Renton, WA 98058, USA",
      "poi_short_description": "Longtime supermarket chain carrying brand-name & house-label groceries, plus a deli, bakery & more.",
      "poi_long_description": "Longtime supermarket chain carrying brand-name & house-label groceries, plus a deli, bakery & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-21bd-7711-b854-9c29f8124737.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-21bd-7711-b854-9c29f8124737",
        "storage_key": "property/6767906449167248/019d0229-21bd-7711-b854-9c29f8124737.webp",
        "width": 586,
        "height": 329
      },
      "poi_business_url": "https://local.safeway.com/safeway/wa/renton/17230-140th-ave-se.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=8176710547567102392&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "safeway",
      "poi_latitude": "47.4474284",
      "poi_longitude": "-122.1524522",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 425-228-1740",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-7535-71dc-acb6-9bcb4952574e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-7535-71dc-acb6-9bcb4952574e",
        "storage_key": "property/6767906449167248/019d0229-7535-71dc-acb6-9bcb4952574e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN5YHWH5nkFQRuEntwuuCeXE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_84e530b9-fce8-4430-8deb-e71bb8a76822",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "QFC",
      "poi_type": "Shopping & Retail",
      "poi_address": "4800 NE 4th St, Renton, WA 98059, USA",
      "poi_short_description": "Supermarket chain selling typical groceries & produce, plus homeware & electronics.",
      "poi_long_description": "Supermarket chain selling typical groceries & produce, plus homeware & electronics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed5-23c3-7539-ab80-0e9fe0373655.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed5-23c3-7539-ab80-0e9fe0373655",
        "storage_key": "property/6767906449167248/01a03ed5-23c3-7539-ab80-0e9fe0373655.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.qfc.com/stores/grocery/wa/renton/renton/705/00871?cid=loc_70500871_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=873129907427132371&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "qfc",
      "poi_latitude": "47.4898837",
      "poi_longitude": "-122.1549439",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 425-226-7086",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-7535-71dc-acb6-9bcb4952574e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-7535-71dc-acb6-9bcb4952574e",
        "storage_key": "property/6767906449167248/019d0229-7535-71dc-acb6-9bcb4952574e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw_b0V9dnkFQR08P2Vgb7HQw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_39c77ae2-bd40-47b1-8081-41e01bae47aa",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "743 Rainier Ave S, Renton, WA 98057, USA",
      "poi_short_description": "Department store selling home items, electronics, toys, sporting goods, groceries and low-priced goods of all kinds.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-2a09-75db-a910-a2d1e1799d8f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-2a09-75db-a910-a2d1e1799d8f",
        "storage_key": "property/6767906449167248/019d0229-2a09-75db-a910-a2d1e1799d8f.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/2516-renton-wa/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=14473892573478233606&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "47.47198969999999",
      "poi_longitude": "-122.2209578",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 425-227-0407",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-7867-725c-a2c8-5a0521bcaad0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-7867-725c-a2c8-5a0521bcaad0",
        "storage_key": "property/6767906449167248/019d0229-7867-725c-a2c8-5a0521bcaad0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJDyCigUxdkFQRBqZVD5yY3cg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_9fe9bef8-b9d8-4ba4-ab8e-079839dd488b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Hop In Grocery",
      "poi_type": "Shopping & Retail",
      "poi_address": "5321 NE 4th St, Renton, WA 98059, USA",
      "poi_short_description": "Convenience store featuring a deli, fried chicken, beer, and espresso, plus a car wash.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed5-25f1-721a-a6e9-20e9cbd539f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed5-25f1-721a-a6e9-20e9cbd539f6",
        "storage_key": "property/6767906449167248/01a03ed5-25f1-721a-a6e9-20e9cbd539f6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5184869037979479474&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hop-in-grocery",
      "poi_latitude": "47.48814549999999",
      "poi_longitude": "-122.1478217",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 425-228-4273",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-785b-772e-bed5-882281c100a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-785b-772e-bed5-882281c100a0",
        "storage_key": "property/6767906449167248/019d0229-785b-772e-bed5-882281c100a0.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJNQqisdFnkFQRsi2wX-ta9Ec",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_560e78b4-3d92-4358-948a-424dd99bbdb9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Tiffany Park Elementary School",
      "poi_type": "Education",
      "poi_address": "1601 Lake Youngs Way SE, Renton, WA 98058, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed5-23d8-71ac-a6a2-3143198b9170.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed5-23d8-71ac-a6a2-3143198b9170",
        "storage_key": "property/6767906449167248/01a03ed5-23d8-71ac-a6a2-3143198b9170.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://tiffanypark.rentonschools.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1257844349407620757&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tiffany-park-elementary-school",
      "poi_latitude": "47.4651021",
      "poi_longitude": "-122.1782255",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 425-204-4850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-786d-72fb-834a-fcb962b9aa93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-786d-72fb-834a-fcb962b9aa93",
        "storage_key": "property/6767906449167248/019d0229-786d-72fb-834a-fcb962b9aa93.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJMyFetYpnkFQRlW4sfcXCdBE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_936a5a81-96e1-4c77-a33a-d150196fb336",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Cascade Elementary School",
      "poi_type": "Education",
      "poi_address": "16022 116th Ave SE, Renton, WA 98058, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed5-2588-741e-a6bb-396bfef341b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed5-2588-741e-a6bb-396bfef341b6",
        "storage_key": "property/6767906449167248/01a03ed5-2588-741e-a6bb-396bfef341b6.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://cascade.rentonschools.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5153831250195172833&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cascade-elementary-school",
      "poi_latitude": "47.4588071",
      "poi_longitude": "-122.1853005",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 425-204-3350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-786d-72fb-834a-fcb962b9aa93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-786d-72fb-834a-fcb962b9aa93",
        "storage_key": "property/6767906449167248/019d0229-786d-72fb-834a-fcb962b9aa93.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdURQkWZdkFQR4c0wRDcWhkc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_5f8fdd53-ee90-48c3-8af8-e1a175f5dda4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Renton Park Elementary School",
      "poi_type": "Education",
      "poi_address": "16828 128th Ave SE, Renton, WA 98058, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed5-2448-728b-9429-df49eb1dce2f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed5-2448-728b-9429-df49eb1dce2f",
        "storage_key": "property/6767906449167248/01a03ed5-2448-728b-9429-df49eb1dce2f.webp",
        "width": 640,
        "height": 305
      },
      "poi_business_url": "https://rentonpark.rentonschools.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9843857913604898640&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "renton-park-elementary-school",
      "poi_latitude": "47.4517946",
      "poi_longitude": "-122.1687734",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 425-204-2950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-786d-72fb-834a-fcb962b9aa93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-786d-72fb-834a-fcb962b9aa93",
        "storage_key": "property/6767906449167248/019d0229-786d-72fb-834a-fcb962b9aa93.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJ8F6iH5dkFQRUH_WD55onIg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_5e519726-c9ba-4d2e-bcc2-74ea2c0ce9e4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Talbot Hill Elementary School",
      "poi_type": "Education",
      "poi_address": "2300 Talbot Rd S, Renton, WA 98055, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-2b56-706e-90a2-0c7409d83ee0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-2b56-706e-90a2-0c7409d83ee0",
        "storage_key": "property/6767906449167248/019d0229-2b56-706e-90a2-0c7409d83ee0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://talbothill.rentonschools.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14464141080357213738&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "talbot-hill-elementary-school",
      "poi_latitude": "47.4585307",
      "poi_longitude": "-122.2111076",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 425-204-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-786d-72fb-834a-fcb962b9aa93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-786d-72fb-834a-fcb962b9aa93",
        "storage_key": "property/6767906449167248/019d0229-786d-72fb-834a-fcb962b9aa93.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJt5aXdj9dkFQRKpbTo63zusg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_b8cf43c8-1695-488f-a661-ee445ae650bd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Nelsen Middle School",
      "poi_type": "Education",
      "poi_address": "2403 Jones Ave S, Renton, WA 98055, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed5-2531-726b-bfac-8cc850cfd3c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed5-2531-726b-bfac-8cc850cfd3c8",
        "storage_key": "property/6767906449167248/01a03ed5-2531-726b-bfac-8cc850cfd3c8.webp",
        "width": 1280,
        "height": 785
      },
      "poi_business_url": "https://nelsen.rentonschools.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8659905827576355648&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nelsen-middle-school",
      "poi_latitude": "47.457634",
      "poi_longitude": "-122.1981506",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 425-204-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-786d-72fb-834a-fcb962b9aa93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-786d-72fb-834a-fcb962b9aa93",
        "storage_key": "property/6767906449167248/019d0229-786d-72fb-834a-fcb962b9aa93.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJE5OG8mldkFQRQBsG0XcqLng",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_1580f168-0fc8-491f-ab1a-4b8356224801",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Dimmitt Middle School",
      "poi_type": "Education",
      "poi_address": "12320 80th Ave S, Seattle, WA 98178, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-2c77-7468-94bf-67d88773ccbc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-2c77-7468-94bf-67d88773ccbc",
        "storage_key": "property/6767906449167248/019d0229-2c77-7468-94bf-67d88773ccbc.webp",
        "width": 348,
        "height": 260
      },
      "poi_business_url": "https://dimmitt.rentonschools.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12369094783880558207&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dimmitt-middle-school",
      "poi_latitude": "47.4924296",
      "poi_longitude": "-122.2324887",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 425-204-2800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-786d-72fb-834a-fcb962b9aa93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-786d-72fb-834a-fcb962b9aa93",
        "storage_key": "property/6767906449167248/019d0229-786d-72fb-834a-fcb962b9aa93.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8ys9uMZCkFQRf3ZW8ivap6s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_83a8db10-b29f-4953-9643-3d6f60a69805",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Lindbergh High School",
      "poi_type": "Education",
      "poi_address": "16426 128th Ave SE, Renton, WA 98058, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed5-2650-7236-ac94-1d967651e1e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed5-2650-7236-ac94-1d967651e1e8",
        "storage_key": "property/6767906449167248/01a03ed5-2650-7236-ac94-1d967651e1e8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://lindbergh.rentonschools.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15757596064066982643&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lindbergh-high-school",
      "poi_latitude": "47.45421169999999",
      "poi_longitude": "-122.1677126",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 425-204-3200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-786d-72fb-834a-fcb962b9aa93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-786d-72fb-834a-fcb962b9aa93",
        "storage_key": "property/6767906449167248/019d0229-786d-72fb-834a-fcb962b9aa93.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZ-l1j31dkFQR81LOCCI6rto",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_549de07b-f877-46f5-9813-9d5b83590794",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Renton High School",
      "poi_type": "Education",
      "poi_address": "400 S 2nd St, Renton, WA 98057, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed5-52a0-720a-8bb5-ba8da75e3f2f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed5-52a0-720a-8bb5-ba8da75e3f2f",
        "storage_key": "property/6767906449167248/01a03ed5-52a0-720a-8bb5-ba8da75e3f2f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://rentonhs.rentonschools.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4184952512197576707&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "renton-high-school",
      "poi_latitude": "47.481741",
      "poi_longitude": "-122.21197",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 425-204-3400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-786d-72fb-834a-fcb962b9aa93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-786d-72fb-834a-fcb962b9aa93",
        "storage_key": "property/6767906449167248/019d0229-786d-72fb-834a-fcb962b9aa93.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ12ECra5CkFQRA0hqEyPwEzo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_6c642336-01fd-4e15-96a8-1e62939239ed",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Meadow Crest Early Learning Center",
      "poi_type": "Education",
      "poi_address": "1800 Index Ave NE, Renton, WA 98056, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed5-2952-756f-ae44-9e5fdf10fe83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed5-2952-756f-ae44-9e5fdf10fe83",
        "storage_key": "property/6767906449167248/01a03ed5-2952-756f-ae44-9e5fdf10fe83.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://meadowcrest.rentonschools.us/programs/preschool",
      "poi_directions_map_url": "https://maps.google.com/?cid=8004514727385642172&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meadow-crest-early-learning-center",
      "poi_latitude": "47.5082379",
      "poi_longitude": "-122.181429",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 425-204-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-786d-72fb-834a-fcb962b9aa93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-786d-72fb-834a-fcb962b9aa93",
        "storage_key": "property/6767906449167248/019d0229-786d-72fb-834a-fcb962b9aa93.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6XV2IGhokFQRvDQ0Hby_FW8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_aa6f69b1-5821-44a4-9362-ee965d99a9be",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Renton Technical College",
      "poi_type": "Education",
      "poi_address": "3000 NE 4th St, Renton, WA 98056, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-304f-77bf-bc22-31c0a1caa400.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-304f-77bf-bc22-31c0a1caa400",
        "storage_key": "property/6767906449167248/019d0229-304f-77bf-bc22-31c0a1caa400.webp",
        "width": 1280,
        "height": 382
      },
      "poi_business_url": "http://www.rtc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6638912181410752234&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "renton-technical-college",
      "poi_latitude": "47.4893273",
      "poi_longitude": "-122.175813",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 425-235-2352",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-786d-72fb-834a-fcb962b9aa93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-786d-72fb-834a-fcb962b9aa93",
        "storage_key": "property/6767906449167248/019d0229-786d-72fb-834a-fcb962b9aa93.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkWJAogpokFQR6mYAXHQnIlw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_272b2696-9042-4d89-ae78-c82b61961dd5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Regal The Landing",
      "poi_type": "Entertainment",
      "poi_address": "900 N 10th Pl, Renton, WA 98057, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed5-312c-7599-a4de-2506398caa58.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed5-312c-7599-a4de-2506398caa58",
        "storage_key": "property/6767906449167248/01a03ed5-312c-7599-a4de-2506398caa58.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-the-landing-1935?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=17574270547117706458&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regal-the-landing",
      "poi_latitude": "47.498753",
      "poi_longitude": "-122.20335",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-7c25-74ec-8ef7-3d2462888369.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-7c25-74ec-8ef7-3d2462888369",
        "storage_key": "property/6767906449167248/019d0229-7c25-74ec-8ef7-3d2462888369.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJRfdNfxdokFQR2oyPO_NZ5PM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_108afb59-06b6-490d-a42e-d5223dd8937e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Topgolf Renton",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "780 Logan Ave N, Renton, WA 98057, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed3-62c2-70a7-82ed-2059e8de5e23.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed3-62c2-70a7-82ed-2059e8de5e23",
        "storage_key": "property/6767906449167248/01a03ed3-62c2-70a7-82ed-2059e8de5e23.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://topgolf.com/us/renton/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17862906076997390043&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "topgolf-renton",
      "poi_latitude": "47.4949267",
      "poi_longitude": "-122.2063361",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 425-517-0695",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-e75f-72a2-857f-29c7790452ea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-e75f-72a2-857f-29c7790452ea",
        "storage_key": "property/6767906449167248/019d0229-e75f-72a2-857f-29c7790452ea.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJf5TFdg5pkFQR246Yb2_K5fc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indoor_golf_course"
    },
    {
      "id": "custom_cfe42e6a-9472-4571-bf8a-ab621f9d9939",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "8-Bit Arcade",
      "poi_type": "Entertainment",
      "poi_address": "916 S 3rd St, Renton, WA 98057, USA",
      "poi_short_description": "Throwback arcade featuring classic video games, pinball machines & more, plus beer & milkshakes.",
      "poi_long_description": "Throwback arcade featuring classic video games, pinball machines & more, plus beer & milkshakes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed5-2c80-70ba-9468-091fa7d6cff4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed5-2c80-70ba-9468-091fa7d6cff4",
        "storage_key": "property/6767906449167248/01a03ed5-2c80-70ba-9468-091fa7d6cff4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.facebook.com/8bitarcaderenton/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10502704653647525124&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "8-bit-arcade",
      "poi_latitude": "47.47983170000001",
      "poi_longitude": "-122.2049424",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 425-291-7693",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-7842-761d-ab2e-574f32d440a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-7842-761d-ab2e-574f32d440a7",
        "storage_key": "property/6767906449167248/019d0229-7842-761d-ab2e-574f32d440a7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPVXmJKtCkFQRBLWAnTwawZE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "video_arcade"
    },
    {
      "id": "custom_53ea523b-d206-4ba6-b721-eeb59cfabb08",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "The Local 907",
      "poi_type": "Restaurants",
      "poi_address": "907 S 3rd St, Renton, WA 98057, USA",
      "poi_short_description": "Easygoing outpost for pub fare, draft beers, wines, plus televised sports & pool, trivia & comedy.",
      "poi_long_description": "Easygoing outpost for pub fare, draft beers, wines, plus televised sports & pool, trivia & comedy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed5-2b5d-73ee-801a-abcb4d25332c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed5-2b5d-73ee-801a-abcb4d25332c",
        "storage_key": "property/6767906449167248/01a03ed5-2b5d-73ee-801a-abcb4d25332c.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14703504594176538825&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-local-907",
      "poi_latitude": "47.479555",
      "poi_longitude": "-122.2049893",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 425-255-2511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-7535-71dc-acb6-95a0e7a7d037.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-7535-71dc-acb6-95a0e7a7d037",
        "storage_key": "property/6767906449167248/019d0229-7535-71dc-acb6-95a0e7a7d037.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhy2-OqtCkFQRyXg3oYZXDcw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_666cbbf1-3432-4742-afbe-9151ce9adbfd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Renton Civic Theatre",
      "poi_type": "Entertainment",
      "poi_address": "507 S 3rd St, Renton, WA 98057, USA",
      "poi_short_description": "Old-school performance venue showcasing dramatic & comedic plays & stand-up in a 1920s movie house.",
      "poi_long_description": "Old-school performance venue showcasing dramatic & comedic plays & stand-up in a 1920s movie house.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed5-2b6f-779c-90a8-b6aae1f95f10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed5-2b6f-779c-90a8-b6aae1f95f10",
        "storage_key": "property/6767906449167248/01a03ed5-2b6f-779c-90a8-b6aae1f95f10.webp",
        "width": 920,
        "height": 360
      },
      "poi_business_url": "http://rentoncivictheatre.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8016928599467220396&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "renton-civic-theatre",
      "poi_latitude": "47.47961799999999",
      "poi_longitude": "-122.210165",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 425-226-5529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-7842-761d-ab2e-574f32d440a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-7842-761d-ab2e-574f32d440a7",
        "storage_key": "property/6767906449167248/019d0229-7842-761d-ab2e-574f32d440a7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFz13jqxCkFQRrN3p8BXaQW8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_ef364df6-17c7-4975-a9d4-b494e69f0c37",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Gene Coulon Memorial Beach Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1201 Lake Washington Blvd N, Renton, WA 98056, USA",
      "poi_short_description": "Public 57-acre lakeside park offering boat launches, a walking trail, tennis courts & picnic areas.",
      "poi_long_description": "Public 57-acre lakeside park offering boat launches, a walking trail, tennis courts & picnic areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed3-a210-777c-9570-15eb26f2a127.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed3-a210-777c-9570-15eb26f2a127",
        "storage_key": "property/6767906449167248/01a03ed3-a210-777c-9570-15eb26f2a127.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rentonwa.gov/Activities-Events/Parks-and-Trails/Gene-Coulon-Memorial-Beach-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=17299332345453938081&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gene-coulon-memorial-beach-park",
      "poi_latitude": "47.5068943",
      "poi_longitude": "-122.2020264",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 425-430-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-7c2b-748d-bc15-9f6e661c4a77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-7c2b-748d-bc15-9f6e661c4a77",
        "storage_key": "property/6767906449167248/019d0229-7c2b-748d-bc15-9f6e661c4a77.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJk7HarTlokFQRoQU1xhyTE_A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_5232e6db-6371-4cad-af4c-59ae41a3d5c8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Sure Lock Escapes- Renton",
      "poi_type": "Entertainment",
      "poi_address": "17130 116th Ave SE, Renton, WA 98058, USA",
      "poi_short_description": "Escape destination featuring uniquely themed rooms (pirates, mines etc.) with puzzles.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed5-31b3-731a-b6c5-802b4646172d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed5-31b3-731a-b6c5-802b4646172d",
        "storage_key": "property/6767906449167248/01a03ed5-31b3-731a-b6c5-802b4646172d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://surelockescapes.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1129137074452803227&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sure-lock-escapes--renton",
      "poi_latitude": "47.449648",
      "poi_longitude": "-122.1854144",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 253-987-6899",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-7842-761d-ab2e-574f32d440a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-7842-761d-ab2e-574f32d440a7",
        "storage_key": "property/6767906449167248/019d0229-7842-761d-ab2e-574f32d440a7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn6hj9shdkFQRm6570S-Aqw8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_b084815d-a1fb-452f-bfd1-d44ded64ba5b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Henry Moses Aquatic Center",
      "poi_type": "Entertainment",
      "poi_address": "1719 Maple Vly Hwy, Renton, WA 98057, USA",
      "poi_short_description": "Kids-friendly water park featuring a wave pool, a lazy river and slides and a heated pool.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed3-a763-727c-b291-7ad9f0157f56.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed3-a763-727c-b291-7ad9f0157f56",
        "storage_key": "property/6767906449167248/01a03ed3-a763-727c-b291-7ad9f0157f56.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rentonwa.gov/HMAC",
      "poi_directions_map_url": "https://maps.google.com/?cid=313983733861091180&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "henry-moses-aquatic-center",
      "poi_latitude": "47.481777",
      "poi_longitude": "-122.1949816",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 425-430-6780",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-7842-761d-ab2e-574f32d440a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-7842-761d-ab2e-574f32d440a7",
        "storage_key": "property/6767906449167248/019d0229-7842-761d-ab2e-574f32d440a7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq5qPmf5nkFQRbIcK2op-WwQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_ec33ae39-524a-4c27-935f-e2357c34e4a7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Valley Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "400 S 43rd St, Renton, WA 98055, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-44af-71d2-a773-7b763dba4d10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-44af-71d2-a773-7b763dba4d10",
        "storage_key": "property/6767906449167248/019d0229-44af-71d2-a773-7b763dba4d10.webp",
        "width": 750,
        "height": 500
      },
      "poi_business_url": "http://www.valleymed.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6634061436974118693&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "valley-medical-center",
      "poi_latitude": "47.4428037",
      "poi_longitude": "-122.2138885",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 425-690-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-7c51-72de-be9c-82064af30483.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-7c51-72de-be9c-82064af30483",
        "storage_key": "property/6767906449167248/019d0229-7c51-72de-be9c-82064af30483.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJMS9badNqkFQRJbf1aLrrEFw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_4b267a92-3b98-4b2f-80e2-9a771a324846",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "North Benson - Urgent Care - Valley Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "10555 SE Carr Rd, Renton, WA 98055, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed5-3061-77c8-a75f-f15b7bde33f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed5-3061-77c8-a75f-f15b7bde33f3",
        "storage_key": "property/6767906449167248/01a03ed5-3061-77c8-a75f-f15b7bde33f3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12781229263468512991&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-benson---urgent-care---valley-medical-center",
      "poi_latitude": "47.44457389999999",
      "poi_longitude": "-122.1994336",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 425-690-3470",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-7842-761d-ab2e-574f32d440a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-7842-761d-ab2e-574f32d440a7",
        "storage_key": "property/6767906449167248/019d0229-7842-761d-ab2e-574f32d440a7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ65kSTAxdkFQR30beGUwMYLE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_d5457ea8-c06a-4cb2-80eb-6fbd9165ab15",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "MinuteClinic at CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "10712 SE Carr Rd, Renton, WA 98055, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-458d-7688-b044-8bf594d18950.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-458d-7688-b044-8bf594d18950",
        "storage_key": "property/6767906449167248/019d0229-458d-7688-b044-8bf594d18950.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.cvs.com/minuteclinic/clinic-locator/wa/renton/10285.html?WT.mc_id=LS_mc_google_carenav_10285",
      "poi_directions_map_url": "https://maps.google.com/?cid=2898854750184186070&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "minuteclinic-at-cvs",
      "poi_latitude": "47.4455864",
      "poi_longitude": "-122.1977389",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 866-389-2727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-7842-761d-ab2e-574f32d440a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-7842-761d-ab2e-574f32d440a7",
        "storage_key": "property/6767906449167248/019d0229-7842-761d-ab2e-574f32d440a7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJQwgKa1dkFQR1qAuWAnNOig",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_5e0e54b1-2eac-4549-ba0d-002fe3933589",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "KlickWay Athletics",
      "poi_type": "Health and Wellness",
      "poi_address": "16410 SE 128th St, Renton, WA 98059, USA",
      "poi_short_description": "Relaxed, clean and modern gym featuring weights, machines and cardio equipment, along with personal training options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed5-33ff-7459-8239-5c325449faaf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed5-33ff-7459-8239-5c325449faaf",
        "storage_key": "property/6767906449167248/01a03ed5-33ff-7459-8239-5c325449faaf.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.klickwayathletics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10164750583574288155&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "klickway-athletics",
      "poi_latitude": "47.4884048",
      "poi_longitude": "-122.1209764",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 888-400-1442",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-7842-761d-ab2e-574f32d440a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-7842-761d-ab2e-574f32d440a7",
        "storage_key": "property/6767906449167248/019d0229-7842-761d-ab2e-574f32d440a7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFfd91jZmkFQRG9dj9MxyEI0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b47157ff-525f-436b-b4d9-9b73eba7796b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Renton Community Center",
      "poi_type": "Entertainment",
      "poi_address": "1715 Maple Vly Hwy, Renton, WA 98057, USA",
      "poi_short_description": "Family-friendly community center featuring basketball courts, a gym and a dance hall.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed5-2f14-7799-8c75-7c8e154df786.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed5-2f14-7799-8c75-7c8e154df786",
        "storage_key": "property/6767906449167248/01a03ed5-2f14-7799-8c75-7c8e154df786.webp",
        "width": 480,
        "height": 320
      },
      "poi_business_url": "http://rentonwa.gov/rcc/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2925307876791074414&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "renton-community-center",
      "poi_latitude": "47.4812523",
      "poi_longitude": "-122.1971102",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 425-430-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-7842-761d-ab2e-574f32d440a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-7842-761d-ab2e-574f32d440a7",
        "storage_key": "property/6767906449167248/019d0229-7842-761d-ab2e-574f32d440a7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeZyffgBokFQRbr7I1gPImCg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "community_center"
    },
    {
      "id": "custom_0a825d53-135e-4ea9-abd5-436afd71f57a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Cedar River Yoga",
      "poi_type": "Health and Wellness",
      "poi_address": "2000 Benson Rd S #225, Renton, WA 98055, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed5-33e4-7138-8a8a-275873f3d00a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed5-33e4-7138-8a8a-275873f3d00a",
        "storage_key": "property/6767906449167248/01a03ed5-33e4-7138-8a8a-275873f3d00a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cedarriveryoga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13178342734368534481&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cedar-river-yoga",
      "poi_latitude": "47.4629054",
      "poi_longitude": "-122.2033451",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 425-545-1263",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-786d-72fb-834a-fcb962b9aa93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-786d-72fb-834a-fcb962b9aa93",
        "storage_key": "property/6767906449167248/019d0229-786d-72fb-834a-fcb962b9aa93.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8-xpibddkFQR0e9iIuXg4rY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_bd1198a6-84e8-4986-b973-816d8148cbde",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Maya Whole Health Studio",
      "poi_type": "Health and Wellness",
      "poi_address": "1322 Lake Washington Blvd N Ste 3, Renton, WA 98056, USA",
      "poi_short_description": "Fitness studio with Pilates mat classes & yoga sessions in various styles, plus an apparel shop.",
      "poi_long_description": "Fitness studio with Pilates mat classes & yoga sessions in various styles, plus an apparel shop.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.mayawholehealth.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14159156082498600237&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maya-whole-health-studio",
      "poi_latitude": "47.50421919999999",
      "poi_longitude": "-122.1992052",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 425-271-0200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-786d-72fb-834a-fcb962b9aa93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-786d-72fb-834a-fcb962b9aa93",
        "storage_key": "property/6767906449167248/019d0229-786d-72fb-834a-fcb962b9aa93.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJu4Wr-D1okFQRLf2jSHBtf8Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_9e7c177b-0480-48fe-9a4c-67fd8e01811b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Imagine Hot Yoga & Wellness",
      "poi_type": "Health and Wellness",
      "poi_address": "14201 SE Petrovitsky Rd #a1, Renton, WA 98058, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed5-35f4-703f-bad5-b1714c24be2b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed5-35f4-703f-bad5-b1714c24be2b",
        "storage_key": "property/6767906449167248/01a03ed5-35f4-703f-bad5-b1714c24be2b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.imaginehotyoga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13351800680095677060&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "imagine-hot-yoga--wellness",
      "poi_latitude": "47.444367",
      "poi_longitude": "-122.1520158",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 425-462-4646",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-786d-72fb-834a-fcb962b9aa93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-786d-72fb-834a-fcb962b9aa93",
        "storage_key": "property/6767906449167248/019d0229-786d-72fb-834a-fcb962b9aa93.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4wGht1RnkFQRhPrrSPofS7k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_cd57bc81-5f36-480f-90f8-9a726022ebe7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Thomas Teasdale Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "601 S 23rd St, Renton, WA 98055, USA",
      "poi_short_description": "Community park with basketball courts, baseball diamonds, summer restrooms & a playground.",
      "poi_long_description": "Community park with basketball courts, baseball diamonds, summer restrooms & a playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed5-395a-74c8-b4b4-9dd91d74d8a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed5-395a-74c8-b4b4-9dd91d74d8a4",
        "storage_key": "property/6767906449167248/01a03ed5-395a-74c8-b4b4-9dd91d74d8a4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13052201921801205046&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "thomas-teasdale-park",
      "poi_latitude": "47.4584171",
      "poi_longitude": "-122.2082133",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 425-430-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-7c2b-748d-bc15-9f6e661c4a77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-7c2b-748d-bc15-9f6e661c4a77",
        "storage_key": "property/6767906449167248/019d0229-7c2b-748d-bc15-9f6e661c4a77.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ38YGZEBdkFQRNrWhjX68IrU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_9d5f6f3e-453f-447b-ad23-015cce5151ea",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Philip Arnold Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "720 Jones Ave S, Renton, WA 98057, USA",
      "poi_short_description": "Neighborhood park providing a playground, BBQ/picnic shelter, sports fields/courts & restrooms.",
      "poi_long_description": "Neighborhood park providing a playground, BBQ/picnic shelter, sports fields/courts & restrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed5-3768-7784-86ae-69476d6b487d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed5-3768-7784-86ae-69476d6b487d",
        "storage_key": "property/6767906449167248/01a03ed5-3768-7784-86ae-69476d6b487d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.rentonwa.gov/Government/Departments-and-Offices/Parks-and-Recreation/Parks-and-Trails",
      "poi_directions_map_url": "https://maps.google.com/?cid=15883454248257316635&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "philip-arnold-park",
      "poi_latitude": "47.4722739",
      "poi_longitude": "-122.1955462",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 425-430-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-7c2b-748d-bc15-9f6e661c4a77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-7c2b-748d-bc15-9f6e661c4a77",
        "storage_key": "property/6767906449167248/019d0229-7c2b-748d-bc15-9f6e661c4a77.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJde_DbVddkFQRG-eLEXxdbdw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_4c7b2e8c-aa97-4a6e-b093-25551f531ef6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Jones Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "98 Wells Ave S, Renton, WA 98058, USA",
      "poi_short_description": "Riverside playground with a dragon, a grass-covered area and a skate park.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed5-369e-76dd-a40e-f5a547671ac5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed5-369e-76dd-a40e-f5a547671ac5",
        "storage_key": "property/6767906449167248/01a03ed5-369e-76dd-a40e-f5a547671ac5.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10591091170454458945&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jones-park",
      "poi_latitude": "47.4828212",
      "poi_longitude": "-122.2049242",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 425-430-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-7c2b-748d-bc15-9f6e661c4a77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-7c2b-748d-bc15-9f6e661c4a77",
        "storage_key": "property/6767906449167248/019d0229-7c2b-748d-bc15-9f6e661c4a77.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2f30VoXG5YgRQdK2Nk4d-5I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6ee3ee86-ecfa-4d2e-8018-378ec8a01933",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Cedar River Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1500 Houser Way S, Renton, WA 98057, USA",
      "poi_short_description": "Fenced-in area for dogs with a trail and separate area for small dogs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed5-3bc3-734c-96aa-1bab02a68727.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed5-3bc3-734c-96aa-1bab02a68727",
        "storage_key": "property/6767906449167248/01a03ed5-3bc3-734c-96aa-1bab02a68727.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://www.rentonwa.gov/city_hall/parks_and_recreation/parks_and_trails/find_a_park_or_trail/cedar_river_dog_park",
      "poi_directions_map_url": "https://maps.google.com/?cid=12738260073389148685&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cedar-river-dog-park",
      "poi_latitude": "47.4785123",
      "poi_longitude": "-122.1960855",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-7c2b-748d-bc15-9f6e661c4a77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-7c2b-748d-bc15-9f6e661c4a77",
        "storage_key": "property/6767906449167248/019d0229-7c2b-748d-bc15-9f6e661c4a77.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZxQ2ilRnkFQRDcrm6gtkx7A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "custom_69c1f7c4-5c7f-47e0-8b79-22e974203cb7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Cedar River Trail Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1060 Nishiwaki Ln, Renton, WA 98057, USA",
      "poi_short_description": "4-acre off-leash dog park surrounded by a split-rail fence, with separate area for shy & small dogs.",
      "poi_long_description": "4-acre off-leash dog park surrounded by a split-rail fence, with separate area for shy & small dogs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed5-3951-7118-a26b-c798bcbe944b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed5-3951-7118-a26b-c798bcbe944b",
        "storage_key": "property/6767906449167248/01a03ed5-3951-7118-a26b-c798bcbe944b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17412972418870506425&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cedar-river-trail-park",
      "poi_latitude": "47.4953951",
      "poi_longitude": "-122.213531",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 425-430-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-7c2b-748d-bc15-9f6e661c4a77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-7c2b-748d-bc15-9f6e661c4a77",
        "storage_key": "property/6767906449167248/019d0229-7c2b-748d-bc15-9f6e661c4a77.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ96Zrwh1okFQRuXNzNihOp_E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_2c8a776b-a499-4503-9abf-8ac7a029b8be",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Riverview Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3201 Maple Vly Hwy, Renton, WA 98058, USA",
      "poi_short_description": "Kid-friendly, grassy park showcasing a bridge and trails and known for salmon viewing.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed5-3912-7061-9f23-b15b74ccfdca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed5-3912-7061-9f23-b15b74ccfdca",
        "storage_key": "property/6767906449167248/01a03ed5-3912-7061-9f23-b15b74ccfdca.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11234560571580135826&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riverview-park",
      "poi_latitude": "47.47724119999999",
      "poi_longitude": "-122.1805637",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 425-430-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-7c2b-748d-bc15-9f6e661c4a77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-7c2b-748d-bc15-9f6e661c4a77",
        "storage_key": "property/6767906449167248/019d0229-7c2b-748d-bc15-9f6e661c4a77.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJEV15lPpnkFQRkrmkDFEt6Zs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_8b931457-664a-4af7-bcfa-ea444a757c3d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Piazza Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "233 Burnett Ave S, Renton, WA 98057, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed5-44ab-71fe-abec-b522e186c1c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed5-44ab-71fe-abec-b522e186c1c7",
        "storage_key": "property/6767906449167248/01a03ed5-44ab-71fe-abec-b522e186c1c7.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3433298099737492134&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "piazza-park",
      "poi_latitude": "47.4802261",
      "poi_longitude": "-122.2084445",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 425-430-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-7c2b-748d-bc15-9f6e661c4a77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-7c2b-748d-bc15-9f6e661c4a77",
        "storage_key": "property/6767906449167248/019d0229-7c2b-748d-bc15-9f6e661c4a77.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ653Us6FDkFQRpnrgam6GpS8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2dcc1e05-0f2e-43ac-a15a-57c6cf845e5b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Kennydale Beach Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3601 Lake Washington Blvd N, Renton, WA 98056, USA",
      "poi_short_description": "Small beach park with seasonal lifeguards, offering a swimming area, picnic tables & a playground.",
      "poi_long_description": "Small beach park with seasonal lifeguards, offering a swimming area, picnic tables & a playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-5047-7678-9b7e-5d4c0caafd26.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-5047-7678-9b7e-5d4c0caafd26",
        "storage_key": "property/6767906449167248/019d0229-5047-7678-9b7e-5d4c0caafd26.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://rentonwa.gov/city_hall/parks_and_recreation/parks_and_trails/find_a_park_or_trail/kennydale_beach_park",
      "poi_directions_map_url": "https://maps.google.com/?cid=2833718910669120952&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kennydale-beach-park",
      "poi_latitude": "47.5236272",
      "poi_longitude": "-122.2075471",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 425-430-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-7c2b-748d-bc15-9f6e661c4a77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-7c2b-748d-bc15-9f6e661c4a77",
        "storage_key": "property/6767906449167248/019d0229-7c2b-748d-bc15-9f6e661c4a77.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ93AqmbRpkFQRuGW951VkUyc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_d2e3b042-a471-4ca4-9b3e-6e334363bdaa",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Maplewood Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "SE 136th St &, 146th Ave SE, Renton, WA 98059, USA",
      "poi_short_description": "Laid-back park featuring trails through a wooded area and a playground for kids.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed5-3edd-729a-8c77-ddba0f0a67fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed5-3edd-729a-8c77-ddba0f0a67fc",
        "storage_key": "property/6767906449167248/01a03ed5-3edd-729a-8c77-ddba0f0a67fc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.kingcounty.gov/environment/dnrp/park_map.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=2749547942951234981&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maplewood-park",
      "poi_latitude": "47.4780468",
      "poi_longitude": "-122.1462419",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 206-296-0100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-7c2b-748d-bc15-9f6e661c4a77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-7c2b-748d-bc15-9f6e661c4a77",
        "storage_key": "property/6767906449167248/019d0229-7c2b-748d-bc15-9f6e661c4a77.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJCcWz4sVnkFQRpa2DUElbKCY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f0ab45da-98f6-4831-ad4d-f762b6c01bbd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Renton Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "257 Burnett Ave S, Renton, WA 98057, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-61b2-7396-883f-84c0342fd475.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-61b2-7396-883f-84c0342fd475",
        "storage_key": "property/6767906449167248/019d0229-61b2-7396-883f-84c0342fd475.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://kingcounty.gov/depts/transportation/metro/schedules-maps/maps/boarding/renton-tc.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=590285674929865941&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "renton-transit-center",
      "poi_latitude": "47.4806339",
      "poi_longitude": "-122.2082357",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 206-553-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-7842-761d-ab2e-574f32d440a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-7842-761d-ab2e-574f32d440a7",
        "storage_key": "property/6767906449167248/019d0229-7842-761d-ab2e-574f32d440a7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ09NR59NDkFQR1UQyorEdMQg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_40ed7c18-cdf2-4b9b-ac9e-8c93408ff38f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "South Renton Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "205 S 7th St, Renton, WA 98057, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed5-4367-706a-8b57-7208bcc839e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed5-4367-706a-8b57-7208bcc839e0",
        "storage_key": "property/6767906449167248/01a03ed5-4367-706a-8b57-7208bcc839e0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=719680142661496012&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-renton-park--ride",
      "poi_latitude": "47.4726238",
      "poi_longitude": "-122.2135019",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-7faa-73eb-bce3-840436d306f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-7faa-73eb-bce3-840436d306f4",
        "storage_key": "property/6767906449167248/019d0229-7faa-73eb-bce3-840436d306f4.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJR9ils01dkFQRzKw910bR_Ak",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_d7a641b9-42d5-4a16-a259-50308cb95f09",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "City Center Parking Garage",
      "poi_type": "Transportation & Transit",
      "poi_address": "655 S 2nd St, Renton, WA 98057, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed5-43a3-77a9-8ebe-a7b52af62f0b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed5-43a3-77a9-8ebe-a7b52af62f0b",
        "storage_key": "property/6767906449167248/01a03ed5-43a3-77a9-8ebe-a7b52af62f0b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.rentonwa.gov/Government/Departments-and-Offices/Public-Works/City-Center-Parking-Garage",
      "poi_directions_map_url": "https://maps.google.com/?cid=9674545597097325626&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-center-parking-garage",
      "poi_latitude": "47.4809529",
      "poi_longitude": "-122.2085854",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 425-430-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-7faa-73eb-bce3-840436d306f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-7faa-73eb-bce3-840436d306f4",
        "storage_key": "property/6767906449167248/019d0229-7faa-73eb-bce3-840436d306f4.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJvU-3m6tCkFQROjRObvbjQoY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_077f7087-c4e2-4a10-aa4f-1a6798a21d35",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Tukwila",
      "poi_type": "Transportation & Transit",
      "poi_address": "7301 Longacres Way, Tukwila, WA 98188, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed3-7f89-7749-a3da-972ff2cef13c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed3-7f89-7749-a3da-972ff2cef13c",
        "storage_key": "property/6767906449167248/01a03ed3-7f89-7749-a3da-972ff2cef13c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=TUK",
      "poi_directions_map_url": "https://maps.google.com/?cid=7463838225028263000&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tukwila",
      "poi_latitude": "47.4607623",
      "poi_longitude": "-122.2405253",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-7fd6-70b0-92ef-0fb51943e727.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-7fd6-70b0-92ef-0fb51943e727",
        "storage_key": "property/6767906449167248/019d0229-7fd6-70b0-92ef-0fb51943e727.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJpcZcuC5dkFQRWKzKD1LhlGc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_507306c2-13d6-40c7-a8bd-eb8bb336b345",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Tukwila Int'l Blvd",
      "poi_type": "Transportation & Transit",
      "poi_address": "3651 Southcenter Blvd, Tukwila, WA 98188, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed3-80da-7390-a318-adfa48a2fb1a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed3-80da-7390-a318-adfa48a2fb1a",
        "storage_key": "property/6767906449167248/01a03ed3-80da-7390-a318-adfa48a2fb1a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.soundtransit.org/ride-with-us/stops-stations/tukwila-international-boulevard-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=3918699620542677033&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tukwila-intl-blvd",
      "poi_latitude": "47.4640995",
      "poi_longitude": "-122.2882273",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed3-f7a8-74a4-b780-f713d9742a44.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03ed3-f7a8-74a4-b780-f713d9742a44",
        "storage_key": "property/6767906449167248/01a03ed3-f7a8-74a4-b780-f713d9742a44.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1XkFKzhDkFQRKYDn74oEYjY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_03db07f1-6586-4edd-9893-b00715942c5d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Seattle-Tacoma International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "17801 International Blvd, SeaTac, WA 98158, USA",
      "poi_short_description": "Large hub serving the Pacific Northwest & featuring live music plus rail service to Seattle.",
      "poi_long_description": "Large hub serving the Pacific Northwest & featuring live music plus rail service to Seattle.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-67a9-737c-9123-bf1c7eb95c90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0229-67a9-737c-9123-bf1c7eb95c90",
        "storage_key": "property/6767906449167248/019d0229-67a9-737c-9123-bf1c7eb95c90.webp",
        "width": 1200,
        "height": 798
      },
      "poi_business_url": "https://www.portseattle.org/sea-tac",
      "poi_directions_map_url": "https://maps.google.com/?cid=11084442547078838199&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seattle-tacoma-international-airport",
      "poi_latitude": "47.4483652",
      "poi_longitude": "-122.3085927",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-8051-76ee-a3a1-d37ecf025377.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-8051-76ee-a3a1-d37ecf025377",
        "storage_key": "property/6767906449167248/019d0229-8051-76ee-a3a1-d37ecf025377.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_f7qQlVDkFQRtzfcx8TZ05k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_45928f73-7bae-4c19-8c82-c149f40cbe0d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Talbot Rd S & S Renton Village Pl",
      "poi_type": "Transportation & Transit",
      "poi_address": "Renton, WA 98057, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11563712793474875832&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "talbot-rd-s--s-renton-village-pl",
      "poi_latitude": "47.47076999999999",
      "poi_longitude": "-122.20798",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed5-5dc4-75dd-8c83-37d2babf46b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03ed5-5dc4-75dd-8c83-37d2babf46b7",
        "storage_key": "property/6767906449167248/01a03ed5-5dc4-75dd-8c83-37d2babf46b7.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJK8VXO05dkFQRuMG1u4SPeqA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_24a12fe1-23a3-4672-a1c9-9dfe4d7e48c7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Boeing Renton",
      "poi_type": "Transportation & Transit",
      "poi_address": "737 Logan Ave N, Renton, WA 98057, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.boeing.com/company/about-bca/renton-production-facility",
      "poi_directions_map_url": "https://maps.google.com/?cid=9973960158647336741&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boeing-renton",
      "poi_latitude": "47.49531959999999",
      "poi_longitude": "-122.2090109",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-7842-761d-ab2e-574f32d440a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-7842-761d-ab2e-574f32d440a7",
        "storage_key": "property/6767906449167248/019d0229-7842-761d-ab2e-574f32d440a7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMb6CDgBpkFQRJb8ShOufaoo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_782e5731-b824-45e0-9359-75a165e4817a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Paccar Parts Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "405 Houser Way N, Renton, WA 98057, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed5-477e-726c-a74a-2cc2a32dc23d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed5-477e-726c-a74a-2cc2a32dc23d",
        "storage_key": "property/6767906449167248/01a03ed5-477e-726c-a74a-2cc2a32dc23d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.paccarparts.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3950404541294792350&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "paccar-parts-center",
      "poi_latitude": "47.4893565",
      "poi_longitude": "-122.1964569",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-7842-761d-ab2e-574f32d440a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-7842-761d-ab2e-574f32d440a7",
        "storage_key": "property/6767906449167248/019d0229-7842-761d-ab2e-574f32d440a7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfQxkRYlpkFQRnk73CgCo0jY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "storage"
    },
    {
      "id": "custom_37242ffa-b4f5-4877-a5cd-16475432677c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Renton City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1055 S Grady Way, Renton, WA 98057, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed3-9fac-7191-b1ee-efb8d073c5f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed3-9fac-7191-b1ee-efb8d073c5f9",
        "storage_key": "property/6767906449167248/01a03ed3-9fac-7191-b1ee-efb8d073c5f9.webp",
        "width": 1280,
        "height": 957
      },
      "poi_business_url": "http://rentonwa.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1274733248939844054&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "renton-city-hall",
      "poi_latitude": "47.4747631",
      "poi_longitude": "-122.2047575",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 425-430-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-82b9-73f4-a7de-21c5f2836d6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-82b9-73f4-a7de-21c5f2836d6a",
        "storage_key": "property/6767906449167248/019d0229-82b9-73f4-a7de-21c5f2836d6a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJITiwwVNdkFQR1mFw1iLDsBE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_fa259047-f201-4374-90ce-3474268808ea",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Amazon Fulfillment Center- BFI4",
      "poi_type": "Major Employers & Offices",
      "poi_address": "21005 64th Ave S, Kent, WA 98032, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed5-469d-728e-965c-37e97d4391ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed5-469d-728e-965c-37e97d4391ae",
        "storage_key": "property/6767906449167248/01a03ed5-469d-728e-965c-37e97d4391ae.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "http://www.amazon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5859741141599635326&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amazon-fulfillment-center--bfi4",
      "poi_latitude": "47.4137515",
      "poi_longitude": "-122.2578145",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 866-216-1072",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-7842-761d-ab2e-574f32d440a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-7842-761d-ab2e-574f32d440a7",
        "storage_key": "property/6767906449167248/019d0229-7842-761d-ab2e-574f32d440a7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgfF6831ckFQRfsfJpIX7UVE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "storage"
    },
    {
      "id": "custom_3682ffd1-1bd1-4cb8-b029-b93547c73ca7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "King County International Airport - Boeing Field",
      "poi_type": "Transportation & Transit",
      "poi_address": "7277 Perimeter Rd S, Seattle, WA 98108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed5-450c-739c-a8fe-97ff31107f00.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed5-450c-739c-a8fe-97ff31107f00",
        "storage_key": "property/6767906449167248/01a03ed5-450c-739c-a8fe-97ff31107f00.webp",
        "width": 1280,
        "height": 792
      },
      "poi_business_url": "https://www.kingcounty.gov/airport",
      "poi_directions_map_url": "https://maps.google.com/?cid=4635828346216693482&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "king-county-international-airport---boeing-field",
      "poi_latitude": "47.5369043",
      "poi_longitude": "-122.3038555",
      "poi_miles_from_property": "9.9",
      "poi_walking_minutes": "3 hours 43 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 206-296-7380",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-8051-76ee-a3a1-d37ecf025377.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-8051-76ee-a3a1-d37ecf025377",
        "storage_key": "property/6767906449167248/019d0229-8051-76ee-a3a1-d37ecf025377.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJt_--ofVBkFQR6r7ut1HFVUA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_223a1153-ce36-4350-ac6a-e47d0718c415",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "custom",
      "poi_name": "Westfield Southcenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "2800 Southcenter Mall, Seattle, WA 98188, USA",
      "poi_short_description": "2-level indoor shopping mall with more than 200 stores & eateries plus a multiplex with IMAX.",
      "poi_long_description": "2-level indoor shopping mall with more than 200 stores & eateries plus a multiplex with IMAX.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/01a03ed3-1b87-719a-aadf-ac4e120e0146.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed3-1b87-719a-aadf-ac4e120e0146",
        "storage_key": "property/6767906449167248/01a03ed3-1b87-719a-aadf-ac4e120e0146.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.westfield.com/en/united-states/southcenter",
      "poi_directions_map_url": "https://maps.google.com/?cid=7722388109786479024&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westfield-southcenter",
      "poi_latitude": "47.4588849",
      "poi_longitude": "-122.257964",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 206-246-0423",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-7867-725c-a2c8-5a0521bcaad0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0229-7867-725c-a2c8-5a0521bcaad0",
        "storage_key": "property/6767906449167248/019d0229-7867-725c-a2c8-5a0521bcaad0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ1W80hNNckFQRsPmFJRJvK2s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    }
  ],
  "office_hours": [
    {
      "id": "ec_f3255a0dfe9cb5884bb6d2da",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_3d4606a9d2609a939d4320df",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_ae15b03795d6197dd6e43e09",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_7fd3444b7ef251a70feb9619",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_cefa1d41f522f2cb64aeeb5d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_4e97fb6c415fd50f92f9ff92",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "rating": "5",
      "name": "Kateryna Starostina",
      "text": "We lived at Regency Woods for 3 years, and it truly was our home from the very beginning. After our first tour with Stephanie, we already knew this was the place where we wanted to live. The community was always peaceful, clean, and beautifully maintained. We loved how green and cared for the property always looked, and it was genuinely comforting to come home every day. Parking was never stressful for us, even with a second car, which made everyday life so much easier. Throughout all the years we lived there, everything was always well taken care of, and communication was always clear and thoughtful. Stephanie and Ian were both incredibly kind and helpful, especially when we were preparing for our move to California and needed help with the lease transfer. They made the process smooth and uncomplicated during a stressful time in our lives. We have so many warm memories from living there and are truly grateful for our experience at Regency Woods. We would absolutely recommend it to anyone looking for a place that is calm, cared for, and genuinely welcoming.",
      "date": "2026-05-23",
      "title": "false"
    },
    {
      "id": "ec_f4224465a0676c59180bb1b9",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "rating": "5",
      "name": "Brianna Charles",
      "text": "My husband and I have been living here for about 4+ years now. One of the best and peaceful apartments I have lived so far. We have been able to grow our little family here. Maintenance help with all our needs pretty quickly, for example I had an emergency with our washer and they came out and fixed right away. The administration office team answer all my questions regarding leasing professionally and are always kind. About a 20 min walk or a short drive to downtown Renton, where you can access farmers market, small businesses and library. Overall great living experience and recommend them if you're looking for an apartment.",
      "date": "2026-04-27",
      "title": "false"
    },
    {
      "id": "ec_8a558d6dfbb9ed67b2c20eca",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "rating": "5",
      "name": "Dylan",
      "text": "Bruce has been an excellent part of our experience as new tenants! Communicative, determined, and a real problem-solver. Coming from out-of-state and touring this property on a whim, he completely sold us and so far our experience has been wonderful 🙂",
      "date": "2026-05-08",
      "title": "false"
    },
    {
      "id": "ec_83c08789eb1b68cc4014bfad",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "rating": "5",
      "name": "Leah Davis",
      "text": "Bruce was great! He made the move in process super easy for me and my family. He was also super communicative which helped a lot!",
      "date": "2026-07-06",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_4072feefc585ae914be267bf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d022a-7ab7-713a-aea5-4f893648b6a7.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room and kitchen area in an apartment",
        "public_id": "019d022a-7ab7-713a-aea5-4f893648b6a7",
        "storage_key": "property/6767906449167248/019d022a-7ab7-713a-aea5-4f893648b6a7.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Model D",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=9Rh3ZkNXNid"
    },
    {
      "id": "ec_be6aa22849affa97f445caf1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019ddcfd-0854-712b-851f-67a2763bd4df.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcfd-0854-712b-851f-67a2763bd4df",
        "storage_key": "property/6767906449167248/019ddcfd-0854-712b-851f-67a2763bd4df.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Model E",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=pLgLscg7YrW"
    },
    {
      "id": "ec_71a126e2dea260a124df5916",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-ee91-7750-946a-6fa49b176abd.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room and dining area with sectional sofa, chairs, and mirrored furniture.",
        "public_id": "019d0229-ee91-7750-946a-6fa49b176abd",
        "storage_key": "property/6767906449167248/019d0229-ee91-7750-946a-6fa49b176abd.webp",
        "width": 984,
        "height": 554
      },
      "virtual_tour_title": "Model C",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=WWjwT35SMu3"
    },
    {
      "id": "ec_8b87aedb79e604777bb95209",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019ddcfd-0834-7338-a9f3-d0369b40e6dd.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcfd-0834-7338-a9f3-d0369b40e6dd",
        "storage_key": "property/6767906449167248/019ddcfd-0834-7338-a9f3-d0369b40e6dd.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Model A",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=YKGhcxRhqS8"
    },
    {
      "id": "ec_903446b29db256988ec4b646",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019ddcfd-08d1-732c-a606-f6430ad00135.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcfd-08d1-732c-a606-f6430ad00135",
        "storage_key": "property/6767906449167248/019ddcfd-08d1-732c-a606-f6430ad00135.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Model F",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=ut7wyF1x6Kr"
    },
    {
      "id": "ec_9d5926ba76166322596f6f4e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019ddcfd-0d95-7363-ab0f-5b1cb4337dc1.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcfd-0d95-7363-ab0f-5b1cb4337dc1",
        "storage_key": "property/6767906449167248/019ddcfd-0d95-7363-ab0f-5b1cb4337dc1.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Model B",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=8uB2NAyebgB"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0b0d0-815c-7488-8228-8ede99cc3a66",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Regency Woods Website",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-renton-hill",
      "search_query": "apartments with in-unit laundry in Renton Hill",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments in Renton Hill",
      "h2_subtitle": "Discover apartments with in-unit laundry at Regency Woods. Enjoy the convenience of laundry facilities right in your own home in Renton Hill.",
      "page_copy": "Regency Woods offers the perfect solution for those seeking apartments with in-unit laundry in Renton Hill. Here, our spacious floor plans include the convenience of private laundry facilities in each unit, allowing you to tackle laundry day from the comfort of your own home. Explore features such as open layouts and select vaulted ceilings within our one-, two-, and three-bedroom apartments, each designed to enhance living experiences.\n\nAt Regency Woods, residents appreciate more than just easy laundry access. Nestled in the scenic community of Renton Hill, enjoy gourmet kitchens outfitted with stainless steel appliances and maple cabinetry. Go beyond the ordinary and see the generous storage options, granite countertops, and occasionally built-in bookshelves available in select homes. You'll find that Regency Woods combines comfort and functionality in every corner. Schedule a tour today to experience it firsthand.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a large apartment building with a distinctive turret.",
        "public_id": "01a03a7d-b3cf-7000-8a2c-f9640733cae5",
        "storage_key": "property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments in Renton Hill",
      "seo_description": "Explore Regency Woods' in-unit laundry apartments in Renton Hill. Enjoy private laundry facilities with spacious layouts and premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "generator",
      "page_item_url": "regency-woods-apartments-pool-renton-wa",
      "search_query": "Regency Woods apartments with pool Renton WA",
      "category": "Amenity",
      "h1_title": "Regency Woods Apartments with Pool",
      "h2_subtitle": "Experience luxury living at Regency Woods apartments, featuring a refreshing pool and premium amenities, located in Renton, WA.",
      "page_copy": "Embrace the ultimate in relaxation and style at Regency Woods, where luxury living meets comfort with our stunning swimming pool feature. Situated in the vibrant community of Renton, WA, our apartments offer residents the perfect place to unwind and enjoy leisure days by the pool. Each spacious one-, two-, and three-bedroom unit is designed with your convenience in mind, boasting in-home laundry, open layouts, and in select models, vaulted ceilings and granite countertops.\n\nBeyond the shimmering pool, Regency Woods delights with its gourmet kitchens equipped with stainless steel appliances and maple cabinetry. Enjoy the scenic views from patios or balconies and appreciate the generous storage available in each unit. Our community is nestled in the desirable Renton Hill, placing you near local attractions while providing a serene environment to call home. Discover the unique blend of comfort and luxury at Regency Woods today by scheduling a tour.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a large apartment building with a distinctive turret.",
        "public_id": "01a03a7d-b3cf-7000-8a2c-f9640733cae5",
        "storage_key": "property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Regency Woods Apartments with Pool",
      "seo_description": "Discover Regency Woods in Renton, WA, featuring apartments with a pool and luxurious amenities. Enjoy stylish living with top comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-renton-98055",
      "search_query": "fitness center apartments in Renton 98055",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in Renton 98055",
      "h2_subtitle": "Find apartments with a fitness center at Regency Woods in Renton, 98055. Combine active living with comfort in our vibrant community.",
      "page_copy": "Enjoy an active and comfortable lifestyle at Regency Woods, where our apartments are complemented by a state-of-the-art fitness center right here in Renton, 98055. Stay on top of your workout routine conveniently without leaving home in our well-equipped facilities. Our spacious one-, two-, and three-bedroom units provide an ideal living space in a community that supports your health and wellness goals.\n\nRegency Woods is more than just its fitness amenities. Nestled in the serene Renton Hill, our apartments feature open layouts, in-home laundry, and select units with vaulted ceilings and scenic views. Dive into culinary adventures in gourmet kitchens complete with stainless steel appliances and maple cabinetry. Our community is designed to cater to not just your fitness needs but also your lifestyle aspirations. Explore the possibility of living in a community that values your well-being by scheduling a visit today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a large apartment building with a distinctive turret.",
        "public_id": "01a03a7d-b3cf-7000-8a2c-f9640733cae5",
        "storage_key": "property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments in Renton 98055",
      "seo_description": "Explore fitness center-equipped apartments at Regency Woods in Renton, 98055. Enjoy luxury living while maintaining an active lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "generator",
      "page_item_url": "apartments-dedicated-parking-king-county",
      "search_query": "apartments with dedicated parking King County",
      "category": "Amenity",
      "h1_title": "Apartments with Dedicated Parking in King County",
      "h2_subtitle": "Discover convenient apartment living in King County with dedicated parking at Regency Woods. Ease your daily routine with secure parking options.",
      "page_copy": "At Regency Woods, we understand the importance of hassle-free parking, which is why we offer apartments with dedicated parking in King County. Our community is designed to provide you with convenience and peace of mind, ensuring that you'll never have to worry about finding a spot when you come home. Enjoy easy access to your vehicle, complementing the numerous other amenities that Regency Woods has to offer.\n\nLocated in the peaceful Renton Hill neighborhood, our spacious one-, two-, and three-bedroom apartments are crafted with quality and practicality. Featuring open layouts, in-home laundry, and select units with features like vaulted ceilings and granite countertops, Regency Woods caters to your every need. Our community also boasts gourmet kitchens with stainless steel appliances, maple cabinetry, and scenic views from private patios or balconies. Join a community that values convenience and comfort by scheduling a tour today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a large apartment building with a distinctive turret.",
        "public_id": "01a03a7d-b3cf-7000-8a2c-f9640733cae5",
        "storage_key": "property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dedicated Parking in King County",
      "seo_description": "Regency Woods offers apartments with dedicated parking in King County. Enjoy convenience with secure parking and essential amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "generator",
      "page_item_url": "luxury-apartments-gourmet-kitchens-renton",
      "search_query": "luxury apartments with gourmet kitchens Renton",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Gourmet Kitchens in Renton",
      "h2_subtitle": "Explore luxury living at Regency Woods, featuring gourmet kitchens and modern amenities in Renton's premier community.",
      "page_copy": "Regency Woods invites you to experience luxury living at its finest with our exquisite apartments boasting gourmet kitchens in Renton. Designed for those who love to cook and entertain, our kitchens feature stainless steel appliances, maple cabinetry, and ample counter space, ideal for culinary creativity. Whether you're hosting a dinner party or simply preparing a meal for yourself, these kitchens will inspire you.\n\nBeyond the kitchen, Regency Woods offers spacious one-, two-, and three-bedroom apartments with features like open layouts, in-home laundry, and select units with vaulted ceilings and scenic views. Nestled in the serene Renton Hill neighborhood, our community provides a perfect blend of tranquility and convenience. Enjoy modern living with premium amenities tailored to suit your lifestyle. Discover what makes Regency Woods the perfect place to call home by scheduling a tour today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a large apartment building with a distinctive turret.",
        "public_id": "01a03a7d-b3cf-7000-8a2c-f9640733cae5",
        "storage_key": "property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Gourmet Kitchens in Renton",
      "seo_description": "Discover luxury apartments with gourmet kitchens at Regency Woods in Renton. Enjoy spacious layouts and modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-renton-hill",
      "search_query": "one bedroom apartments in Renton Hill",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Renton Hill",
      "h2_subtitle": "Experience comfortable living in Renton Hill's one-bedroom apartments at Regency Woods. Enjoy modern amenities and scenic views.",
      "page_copy": "Discover the perfect blend of comfort and style with our one-bedroom apartments in Renton Hill at Regency Woods. Located in a serene neighborhood, these apartments offer a peaceful retreat with the convenience of modern living. Each unit is thoughtfully designed with open layouts, providing plenty of space for relaxation and entertainment.\n\nIn addition to generous floor plans, our one-bedroom apartments feature in-home laundry facilities and select units offer additional luxuries like vaulted ceilings and scenic views. Experience culinary delight in gourmet kitchens equipped with stainless steel appliances and maple cabinetry. Nestled in a prime location, Regency Woods is the ideal choice for those seeking a vibrant community atmosphere with all the amenities you need. Come visit us and see why our one-bedroom homes are the perfect place to settle in Renton.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a large apartment building with a distinctive turret.",
        "public_id": "01a03a7d-b3cf-7000-8a2c-f9640733cae5",
        "storage_key": "property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Renton Hill",
      "seo_description": "Find charming one-bedroom apartments at Regency Woods in Renton Hill. Enjoy modern amenities and spacious living in a peaceful neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-renton-wa",
      "search_query": "two bedroom apartments Renton WA",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Renton, WA",
      "h2_subtitle": "Find your ideal home with spacious two-bedroom apartments at Regency Woods, perfectly located in Renton, WA.",
      "page_copy": "Discover the perfect home for you and yours with our two-bedroom apartments at Regency Woods in Renton, WA. These spacious units offer the ideal environment for comfortable living, featuring open layouts and abundant natural light that cater to various lifestyles. Whether you're a growing family or someone who loves extra space, you'll find our apartments exceed expectations.\n\nLocated in the desirable Renton Hill neighborhood, Regency Woods combines peace and practicality, offering modern amenities like in-home laundry, gourmet kitchens complete with stainless steel appliances, and maple cabinetry. Enjoy relaxing on your private patio or balcony, with select units offering stunning scenic views. Come explore the blend of comfort, style, and convenience at Regency Woods today by scheduling a tour.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a large apartment building with a distinctive turret.",
        "public_id": "01a03a7d-b3cf-7000-8a2c-f9640733cae5",
        "storage_key": "property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Renton, WA",
      "seo_description": "Explore spacious two-bedroom apartments in Renton, WA at Regency Woods. Experience modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-king-county",
      "search_query": "three bedroom apartments in King County",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in King County",
      "h2_subtitle": "Explore spacious three-bedroom apartments at Regency Woods, located in the heart of King County. Experience the best in modern living.",
      "page_copy": "At Regency Woods in King County, discover the perfect blend of space and comfort with our three-bedroom apartments. Designed with families and individuals alike in mind, these apartments offer expansive layouts with features such as gourmet kitchens, complete with stainless steel appliances and maple cabinetry, that are perfect for both cooking and hosting.\n\nNestled in the peaceful Renton Hill area, Regency Woods provides not only a tranquil living environment but also easy access to all of King County's attractions. Enjoy additional amenities including in-home laundry and generous storage options. Select residences even boast vaulted ceilings and beautiful scenic views. Come and see why our three-bedroom apartments are the ideal choice for modern living in King County—schedule your visit today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a large apartment building with a distinctive turret.",
        "public_id": "01a03a7d-b3cf-7000-8a2c-f9640733cae5",
        "storage_key": "property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in King County",
      "seo_description": "Discover spacious three-bedroom apartments in King County at Regency Woods. Enjoy modern living with premium amenities in a serene setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "generator",
      "page_item_url": "apartments-near-tiffany-park-elementary-renton",
      "search_query": "apartments near Tiffany Park Elementary Renton",
      "category": "School",
      "h1_title": "Apartments Near Tiffany Park Elementary",
      "h2_subtitle": "Live close to Tiffany Park Elementary in Renton at Regency Woods. Enjoy convenient access to quality education and modern amenities.",
      "page_copy": "Located conveniently near Tiffany Park Elementary, Regency Woods offers an ideal living experience in Renton for families and individuals alike. Our spacious one-, two-, and three-bedroom apartments provide an inviting atmosphere with open layouts and modern features, perfect for cultivating a comfortable home environment.\n\nAt Regency Woods, residents enjoy amenities designed for modern living, including in-home laundry, gourmet kitchens with stainless steel appliances, and maple cabinetry. Select units feature lush scenic views and vaulted ceilings that add an extra touch of elegance. Our community not only offers a welcoming atmosphere but also the benefit of living near top-rated schools, making it a great choice for families prioritizing education and quality of life. Discover the benefits of living near Tiffany Park Elementary at Regency Woods by scheduling a tour today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a large apartment building with a distinctive turret.",
        "public_id": "01a03a7d-b3cf-7000-8a2c-f9640733cae5",
        "storage_key": "property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Tiffany Park Elementary",
      "seo_description": "Find modern apartments near Tiffany Park Elementary in Renton at Regency Woods. Enjoy convenience and serenity in a family-friendly location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "generator",
      "page_item_url": "regency-woods-close-to-cascade-elementary",
      "search_query": "Regency Woods close to Cascade Elementary School",
      "category": "School",
      "h1_title": "Regency Woods Near Cascade Elementary",
      "h2_subtitle": "Experience great living at Regency Woods, conveniently located close to Cascade Elementary School. Ideal for families seeking quality education.",
      "page_copy": "Make Regency Woods your home and benefit from its prime location close to Cascade Elementary School in Renton. These spacious apartments offer the perfect setting for families who value convenience and community, while also enjoying access to top-rated educational facilities.\n\nWith a selection of one-, two-, and three-bedroom floor plans, Regency Woods offers modern homes featuring in-home laundry facilities, gourmet kitchens with stainless steel appliances, and maple cabinetry. Select apartments boast vaulted ceilings and scenic views, enhancing your living experience. Nestled in the serene Renton Hill neighborhood, you will find both comfort and accessibility, ideal for those balancing work, life, and family. Discover the unique combination of location and lifestyle at Regency Woods today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a large apartment building with a distinctive turret.",
        "public_id": "01a03a7d-b3cf-7000-8a2c-f9640733cae5",
        "storage_key": "property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Regency Woods Near Cascade Elementary",
      "seo_description": "Live at Regency Woods, near Cascade Elementary School. Enjoy spacious apartments perfect for families prioritizing education in Renton.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "generator",
      "page_item_url": "family-friendly-rentals-renton-park-elementary",
      "search_query": "family-friendly rentals by Renton Park Elementary",
      "category": "School",
      "h1_title": "Family-Friendly Rentals Near Renton Park",
      "h2_subtitle": "Discover family-friendly rentals close to Renton Park Elementary. Regency Woods offers a welcoming community ideal for families.",
      "page_copy": "Welcome to Regency Woods, where family-friendly rentals meet convenience near Renton Park Elementary. Whether you're seeking a one-, two-, or three-bedroom apartment, our community provides the perfect home base for families prioritizing proximity to excellent schools.\n\nEach home at Regency Woods is thoughtfully designed with features that include in-home laundry, gourmet kitchens fitted with stainless steel appliances, and maple cabinetry, ensuring comfort and functionality. This serene community in the Renton Hill area also offers beautiful scenic views and select homes with vaulted ceilings, providing an enriched living environment for every member of the family. With easy access to Renton Park Elementary, Regency Woods is an excellent choice for families seeking a supportive and enriching atmosphere.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a large apartment building with a distinctive turret.",
        "public_id": "01a03a7d-b3cf-7000-8a2c-f9640733cae5",
        "storage_key": "property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Family-Friendly Rentals by Renton Park Elementary",
      "seo_description": "Discover family-friendly rentals at Regency Woods, near Renton Park Elementary. Ideal community with spacious apartments for families.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "generator",
      "page_item_url": "talbot-hill-elementary-nearby-apartments-renton-hill",
      "search_query": "Talbot Hill Elementary nearby apartments Renton Hill",
      "category": "School",
      "h1_title": "Renton Hill Apartments Near Talbot Hill",
      "h2_subtitle": "Explore convenient apartment living near Talbot Hill Elementary at Regency Woods. Ideal for families aiming for quality education in Renton Hill.",
      "page_copy": "Regency Woods offers ideal apartment living in Renton Hill, just minutes away from Talbot Hill Elementary. Our family-friendly community provides an excellent living environment for those who value proximity to quality schools.\n\nChoose from our spacious one-, two-, and three-bedroom floor plans, each designed with modern amenities like gourmet kitchens, stainless steel appliances, and maple cabinetry. Select homes feature vaulted ceilings and beautiful views, perfect for relaxing at home. Discover the comfort and convenience of Regency Woods, where the needs of families and individuals are seamlessly met, all within a short distance from Talbot Hill Elementary.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a large apartment building with a distinctive turret.",
        "public_id": "01a03a7d-b3cf-7000-8a2c-f9640733cae5",
        "storage_key": "property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Renton Hill Apartments Near Talbot Hill",
      "seo_description": "Enjoy family-friendly living at Regency Woods, near Talbot Hill Elementary. Discover quality apartments in Renton Hill close to schools.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "generator",
      "page_item_url": "apartments-by-nelsen-middle-school-renton",
      "search_query": "apartments by Nelsen Middle School Renton",
      "category": "School",
      "h1_title": "Apartments Near Nelsen Middle School",
      "h2_subtitle": "Find convenient living at Regency Woods, close to Nelsen Middle School in Renton. Ideal for families and individuals alike.",
      "page_copy": "Discover the unmatched convenience of living at Regency Woods, located near Nelsen Middle School in Renton. Our assortment of one-, two-, and three-bedroom apartments is perfect for families and individuals seeking proximity to educational institutions.\n\nAt Regency Woods, each apartment offers a blend of practicality and elegance, complete with in-home laundry, gourmet kitchens that feature stainless steel appliances, and maple cabinetry. Some units even offer vaulted ceilings and balconies for added comfort. Enjoy the serene surroundings of Renton Hill while benefiting from the community's close-knit atmosphere and ease of access to Nelsen Middle School. Experience a harmonious blend of location and lifestyle at Regency Woods.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a large apartment building with a distinctive turret.",
        "public_id": "01a03a7d-b3cf-7000-8a2c-f9640733cae5",
        "storage_key": "property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Nelsen Middle School",
      "seo_description": "Live at Regency Woods, near Nelsen Middle School in Renton. Spacious apartments ideal for families seeking convenience and quality education.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "generator",
      "page_item_url": "king-county-apartments-near-dimmitt-middle-school",
      "search_query": "King County apartments near Dimmitt Middle School",
      "category": "School",
      "h1_title": "King County Apartments by Dimmitt Middle",
      "h2_subtitle": "Discover ideal apartment living in King County, near Dimmitt Middle School. Regency Woods offers a perfect family-friendly environment.",
      "page_copy": "Regency Woods provides comfortable and convenient living in King County, just a short distance from Dimmitt Middle School. Our range of one-, two-, and three-bedroom apartments caters to families and individuals looking for quality homes that ensure easy access to educational facilities.\n\nFeaturing thoughtful layouts with in-home laundry, gourmet kitchens with stainless steel appliances, and elegant maple cabinetry, our apartments offer both function and style. Select units boast extras like vaulted ceilings and scenic patios or balconies, adding an extra touch of luxury. Nestled in the welcoming Renton Hill neighborhood, Regency Woods presents an unparalleled living experience with the added benefit of being close to Dimmitt Middle School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a large apartment building with a distinctive turret.",
        "public_id": "01a03a7d-b3cf-7000-8a2c-f9640733cae5",
        "storage_key": "property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "King County Apartments by Dimmitt Middle",
      "seo_description": "Experience comfortable living at Regency Woods, near Dimmitt Middle School. Explore our spacious apartments in King County, ideal for families.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "generator",
      "page_item_url": "renton-wa-apartments-close-to-lindbergh-high-school",
      "search_query": "Renton WA apartments close to Lindbergh High School",
      "category": "School",
      "h1_title": "Renton Apartments Near Lindbergh High",
      "h2_subtitle": "Explore Regency Woods Apartments, located close to Lindbergh High School in Renton, WA. Ideal for students and families seeking convenience.",
      "page_copy": "Located in Renton, WA, Regency Woods offers the perfect spot for those looking for apartments close to Lindbergh High School. Our spacious one-, two-, and three-bedroom units provide the ideal setting for families and students who value a convenient commute.\n\nEach apartment is designed for modern comfort, featuring amenities like in-home laundry, gourmet kitchens with stainless steel appliances, and maple cabinetry. Some units have special features such as vaulted ceilings and inviting balconies or patios, providing additional space for relaxation. Positioned in the lovely Renton Hill neighborhood, Regency Woods combines the benefits of community living with proximity to quality education at Lindbergh High School, making it a prime choice for local residents.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a large apartment building with a distinctive turret.",
        "public_id": "01a03a7d-b3cf-7000-8a2c-f9640733cae5",
        "storage_key": "property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Renton Apartments Near Lindbergh High",
      "seo_description": "Live at Regency Woods, close to Lindbergh High School in Renton, WA. Spacious apartments ideal for students and families seeking convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "generator",
      "page_item_url": "regency-woods-apartments-near-renton-high-school",
      "search_query": "Regency Woods apartments near Renton High School",
      "category": "School",
      "h1_title": "Regency Woods: Near Renton High School",
      "h2_subtitle": "Experience living at Regency Woods, conveniently located near Renton High School. Perfect for families prioritizing education accessibility.",
      "page_copy": "Discover the benefits of residing at Regency Woods, ideally situated near Renton High School. Our selection of spacious apartments, ranging from one to three bedrooms, is perfect for families and individuals seeking easy access to excellent educational opportunities.\n\nAt Regency Woods, our apartments feature in-home laundry, gourmet kitchens equipped with stainless steel appliances, and stylish maple cabinetry. Some homes offer additional perks such as vaulted ceilings and private balconies or patios, enhancing your living experience. Nestled in the vibrant Renton Hill neighborhood, Regency Woods not only provides comfort but also ensures seamless commuting to Renton High School, making it the ideal home for education-focused families.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a large apartment building with a distinctive turret.",
        "public_id": "01a03a7d-b3cf-7000-8a2c-f9640733cae5",
        "storage_key": "property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Regency Woods Near Renton High School",
      "seo_description": "Enjoy family-friendly living at Regency Woods, near Renton High School. Spacious apartments with modern amenities in a prime Renton location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "generator",
      "page_item_url": "renton-hill-apartments-by-renton-technical-college",
      "search_query": "Renton Hill apartments by Renton Technical College",
      "category": "School",
      "h1_title": "Renton Hill Living Near Renton Technical",
      "h2_subtitle": "Discover comfortable Renton Hill apartments located conveniently near Renton Technical College. Ideal for students and professionals alike.",
      "page_copy": "Situated in the desirable Renton Hill neighborhood, Regency Woods offers the perfect apartments for those looking to stay close to Renton Technical College. Our one-, two-, and three-bedroom units are designed with comfort and style in mind, making them an excellent choice for students and working professionals.\n\nEach apartment boasts modern amenities such as in-home laundry, gourmet kitchens with sleek stainless steel appliances, and beautiful maple cabinetry. Select units come with vaulted ceilings and scenic views from private patios or balconies, providing a peaceful retreat. Regency Woods combines a prime location near Renton Technical College with the advantages of an engaging community environment, making it a top choice for residents focused on education and convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a large apartment building with a distinctive turret.",
        "public_id": "01a03a7d-b3cf-7000-8a2c-f9640733cae5",
        "storage_key": "property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Renton Hill Apartments by Renton Technical",
      "seo_description": "Live in style at Regency Woods, near Renton Technical College. Spacious Renton Hill apartments ideal for students and professionals seeking convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "generator",
      "page_item_url": "apartments-near-thomas-teasdale-park-renton-hill",
      "search_query": "apartments near Thomas Teasdale Park Renton Hill",
      "category": "Park",
      "h1_title": "Apartments Near Thomas Teasdale Park",
      "h2_subtitle": "Explore Regency Woods apartments, steps away from Thomas Teasdale Park in Renton Hill. Enjoy convenience and nature's beauty.",
      "page_copy": "Nestled in the scenic Renton Hill neighborhood, Regency Woods offers the ideal apartment living experience near Thomas Teasdale Park. Our spacious one-, two-, or three-bedroom apartments are perfect for those who love having a beautiful park right on their doorstep.\n\nRegency Woods features apartment homes that cater to modern lifestyles with in-home laundry, gourmet kitchens adorned with stainless steel appliances, and sophisticated maple cabinetry. Select units offer additional perks like vaulted ceilings and relaxing patios or balconies. Living here means you’re not just close to the natural beauty and recreational opportunities of Thomas Teasdale Park but also connected to a vibrant community in Renton Hill.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a large apartment building with a distinctive turret.",
        "public_id": "01a03a7d-b3cf-7000-8a2c-f9640733cae5",
        "storage_key": "property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Thomas Teasdale Park",
      "seo_description": "Experience Regency Woods living near Thomas Teasdale Park, Renton Hill. Spacious, modern apartments surrounded by scenic beauty.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "generator",
      "page_item_url": "regency-woods-proximity-to-jones-park-wa",
      "search_query": "Regency Woods proximity to Jones Park WA",
      "category": "Park",
      "h1_title": "Regency Woods: Close to Jones Park WA",
      "h2_subtitle": "Enjoy the ideal location of Regency Woods, just moments away from Jones Park WA. Perfect for those who love outdoor activities and nature.",
      "page_copy": "Experience the perfect blend of modern living and natural beauty at Regency Woods, located conveniently near Jones Park WA. Our spacious one-, two-, and three-bedroom apartments offer a serene lifestyle with the advantage of being close to a variety of outdoor recreational activities.\n\nEach home at Regency Woods is fitted with contemporary amenities such as in-home laundry, gourmet kitchens with stainless steel appliances, and exquisite maple cabinetry. Some units include vaulted ceilings and private patios or balconies, enhancing your living experience. With Jones Park WA just a short stroll away, you can enjoy picnics, walks, or simply relax in nature, all within the vibrant Renton Hill community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a large apartment building with a distinctive turret.",
        "public_id": "01a03a7d-b3cf-7000-8a2c-f9640733cae5",
        "storage_key": "property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Regency Woods Near Jones Park WA",
      "seo_description": "Live at Regency Woods in Renton, close to Jones Park WA. Enjoy modern apartments in a location perfect for nature lovers and outdoor enthusiasts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "generator",
      "page_item_url": "cedar-river-dog-park-apartments-king-county",
      "search_query": "Cedar River Dog Park apartments King County",
      "category": "Park",
      "h1_title": "Apartments by Cedar River Dog Park, King County",
      "h2_subtitle": "Discover Regency Woods, located near Cedar River Dog Park in King County. Perfect for dog lovers seeking a pet-friendly community.",
      "page_copy": "Regency Woods offers a pet-friendly apartment community conveniently located near Cedar River Dog Park in King County. Our spacious one-, two-, and three-bedroom apartment homes cater perfectly to pet owners and their furry friends, while providing modern comforts.\n\nResidents enjoy features like in-home laundry, gourmet kitchens equipped with stainless steel appliances, and sleek maple cabinetry. Select units offer vaulted ceilings and private outdoor spaces, perfect for relaxing after a day at the park. Living at Regency Woods means easy access to Cedar River Dog Park, where pet owners can socialize and enjoy a fun, active lifestyle with their pets in the heart of King County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a large apartment building with a distinctive turret.",
        "public_id": "01a03a7d-b3cf-7000-8a2c-f9640733cae5",
        "storage_key": "property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cedar River Dog Park Apartments",
      "seo_description": "Regency Woods: Pet-friendly living near Cedar River Dog Park, King County. Spacious modern apartments perfect for dog owners and their companions.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "generator",
      "page_item_url": "apartments-close-to-piazza-park-renton",
      "search_query": "apartments close to Piazza Park Renton",
      "category": "Park",
      "h1_title": "Apartments Close to Piazza Park, Renton",
      "h2_subtitle": "Find your perfect home at Regency Woods, conveniently located near Piazza Park in Renton. Embrace a vibrant lifestyle in a serene setting.",
      "page_copy": "Situated in the heart of Renton Hill is Regency Woods, offering premium apartment living close to Piazza Park. Our diverse selection of one-, two-, and three-bedroom floor plans provides an ideal home base for those seeking proximity to this lively community centerpiece.\n\nAt Regency Woods, you'll enjoy modern interiors with features such as in-home laundry, gourmet kitchens with stainless steel appliances, and elegant maple cabinetry. Some units come with vaulted ceilings and private patios or balconies, enhancing your comfort. Being close to Piazza Park allows for endless opportunities to enjoy local events, farmers markets, and community gatherings, all while being surrounded by the natural beauty of Renton.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a large apartment building with a distinctive turret.",
        "public_id": "01a03a7d-b3cf-7000-8a2c-f9640733cae5",
        "storage_key": "property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Piazza Park, Renton",
      "seo_description": "Live at Regency Woods, just around the corner from Piazza Park. Modern apartments in Renton Hill offering vibrant living near community hotspots.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "generator",
      "page_item_url": "maplewood-park-nearby-apartments-98055",
      "search_query": "Maplewood Park nearby apartments 98055",
      "category": "Park",
      "h1_title": "Apartments Near Maplewood Park, 98055",
      "h2_subtitle": "Discover Regency Woods, offering stylish living near Maplewood Park in the 98055 area. Ideal for nature lovers seeking outdoor adventures.",
      "page_copy": "Regency Woods, located in the scenic Renton Hill neighborhood, is the perfect community for those seeking apartments near Maplewood Park in the 98055 zip code. Our spacious one-, two-, and three-bedroom floor plans offer the best of modern living with easy access to one of the area's serene outdoor retreats.\n\nEach apartment at Regency Woods comes with luxurious features, including in-home laundry facilities, gourmet kitchens with stainless steel appliances, and beautiful maple cabinetry. Select homes feature vaulted ceilings and private balconies or patios, providing a picturesque view of the surroundings. With Maplewood Park nearby, residents can enjoy a peaceful stroll or partake in various outdoor activities any day of the week.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a large apartment building with a distinctive turret.",
        "public_id": "01a03a7d-b3cf-7000-8a2c-f9640733cae5",
        "storage_key": "property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Maplewood Park Nearby Apartments 98055",
      "seo_description": "Regency Woods offers modern living near Maplewood Park, 98055. Enjoy spacious apartments with easy access to outdoor adventures in Renton Hill.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "generator",
      "page_item_url": "apartments-near-tukwila-intl-blvd-renton-hill",
      "search_query": "apartments near tukwila intl blvd renton hill",
      "category": "Transit",
      "h1_title": "Apartments Near Tukwila Intl Blvd, Renton Hill",
      "h2_subtitle": "Experience convenient living at Regency Woods, close to Tukwila International Boulevard. Ideal for those seeking easy access and modern comfort.",
      "page_copy": "Located in the serene confines of Renton Hill, Regency Woods offers convenient apartment living just a short drive from Tukwila International Boulevard. Choose from our selection of one-, two-, and three-bedroom floor plans, designed to meet the diverse needs of modern renters looking for accessibility to major transport links.\n\nAt Regency Woods, enjoy contemporary interiors complete with in-home laundry, stainless steel kitchen appliances, and elegant maple cabinetry. Select homes also feature spacious private balconies or patios, perfect for enjoying peaceful evenings. With its proximity to Tukwila International Boulevard, residents have easy access to shopping, dining, and transportation options, making everyday commuting and leisure activities a breeze.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a large apartment building with a distinctive turret.",
        "public_id": "01a03a7d-b3cf-7000-8a2c-f9640733cae5",
        "storage_key": "property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Tukwila Intl Blvd, Renton Hill",
      "seo_description": "Regency Woods: Modern apartments in Renton Hill, near Tukwila International Boulevard. Enjoy easy commuting and comfortable living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "generator",
      "page_item_url": "housing-close-to-seattle-tacoma-international-airport-wa",
      "search_query": "housing close to seattle-tacoma international airport wa",
      "category": "Transit",
      "h1_title": "Housing Near Seattle-Tacoma International Airport",
      "h2_subtitle": "Discover Regency Woods, offering prime housing near Seattle-Tacoma International Airport. Perfect for frequent fliers seeking comfort and convenience.",
      "page_copy": "Regency Woods, nestled in the welcoming Renton Hill neighborhood, provides exceptional housing options close to Seattle-Tacoma International Airport (SEA). Our expansive one-, two-, and three-bedroom floor plans make it easy to find a home that suits your lifestyle while keeping you conveniently close to the airport.\n\nEach home at Regency Woods features modern amenities such as in-home laundry, granite countertops, and stainless steel kitchen appliances. For those who enjoy a touch of elegance, select units offer vaulted ceilings and private balconies or patios. Living this close to Seattle-Tacoma International Airport means less travel stress and more time to enjoy the beautiful surroundings of Renton and beyond.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a large apartment building with a distinctive turret.",
        "public_id": "01a03a7d-b3cf-7000-8a2c-f9640733cae5",
        "storage_key": "property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Housing Near Seattle-Tacoma Intl Airport, WA",
      "seo_description": "Stay at Regency Woods, offering comfortable housing near Seattle-Tacoma International Airport. Ideal for travelers seeking convenience and style.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167248",
      "source": "generator",
      "page_item_url": "apartments-near-king-county-intl-airport-boeing-field",
      "search_query": "apartments near king county international airport boeing field",
      "category": "Transit",
      "h1_title": "Apartments Near King County Airport",
      "h2_subtitle": "Live conveniently at Regency Woods, just a short drive from King County International Airport. Perfect for professionals seeking comfort and accessibility.",
      "page_copy": "Located in the welcoming Renton Hill area, Regency Woods offers stylish apartments near King County International Airport, also known as Boeing Field. Our one-, two-, and three-bedroom floor plans are designed for those who value convenience alongside modern living amenities.\n\nResidents at Regency Woods enjoy homes equipped with in-home laundry, luxurious granite countertops, and stainless steel appliances. For added elegance, select units feature vaulted ceilings and private patios or balconies. Being close to King County International Airport not only reduces travel-related hassle but also places you within reach of various retail, dining, and recreation options, enriching your living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a large apartment building with a distinctive turret.",
        "public_id": "01a03a7d-b3cf-7000-8a2c-f9640733cae5",
        "storage_key": "property/6767906449167248/01a03a7d-b3cf-7000-8a2c-f9640733cae5.webp",
        "width": 3072,
        "height": 2046
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near King County Airport",
      "seo_description": "Regency Woods offers convenient living near King County International Airport. Enjoy modern amenities and easy access to Boeing Field, Renton Hill.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11309826983"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=4252564153"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-P73GR4W2"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 7.2"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "e5cbdea9-3cdb-4742-9da2-c9b2e7f2435c"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Belmont"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_pricing_verbiage",
      "type": "STRING",
      "value": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more."
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/ab36a891-052e-46b5-a737-4369e2cbd002/app.js?property=ab36a891-052e-46b5-a737-4369e2cbd002&propertyName=Regency+Woods&channelUuid=c248ee9b-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "47591404058"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Ii9ZbEprKzNPK1Z0a0NWMS9pLzNYakE9PSIsInZhbHVlIjoiL1BKZjZvdkVUN0RuQkFHNFVWemJIZz09IiwibWFjIjoiZjJiMjRmMzVhZGMxOTljM2RjMjFhMjc4YTVkMjJkODdlYjRlZGIzYzYyNGE0ZWIyNWJjY2E0MTY1OWMzZTEwYSJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "11309826983",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=4252564153",
  "custom_google_gtm_id": "GTM-P73GR4W2",
  "custom_rollout_phase": "Phase 7.2",
  "custom_rentgrata_token": "e5cbdea9-3cdb-4742-9da2-c9b2e7f2435c",
  "custom_vibesites_theme": "Belmont",
  "custom_ads_subscription": "none",
  "custom_pricing_verbiage": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more.",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/ab36a891-052e-46b5-a737-4369e2cbd002/app.js?property=ab36a891-052e-46b5-a737-4369e2cbd002&propertyName=Regency+Woods&channelUuid=c248ee9b-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "47591404058",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Ii9ZbEprKzNPK1Z0a0NWMS9pLzNYakE9PSIsInZhbHVlIjoiL1BKZjZvdkVUN0RuQkFHNFVWemJIZz09IiwibWFjIjoiZjJiMjRmMzVhZGMxOTljM2RjMjFhMjc4YTVkMjJkODdlYjRlZGIzYzYyNGE0ZWIyNWJjY2E0MTY1OWMzZTEwYSJ9",
  "custom_audioeye_site_id": "42f0e180-c9ae-4c08-886d-0ba45955f898",
  "custom_audioeye_site_hash": "04b95077def1e017041ceebe1885f1d5"
};

export const generatedAt = '2026-10-29T23:13:12.996Z';
